(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("morningstar"), require("d3"));
	else if(typeof define === 'function' && define.amd)
		define("markets-components-svgplot", ["morningstar", "d3"], factory);
	else if(typeof exports === 'object')
		exports["markets-components-svgplot"] = factory(require("morningstar"), require("d3"));
	else
		root["markets-components-svgplot"] = factory(root["morningstar"], root["d3"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(morningstar) {
	    'use strict';
	
	    var QSAPI = morningstar.components["markets-components-core"];
	    return QSAPI.components.register('svgplot', __webpack_require__(2));
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(plotter) {
	    "use strict";
	
	    function init(container, component) {
	        var configuration = component.configuration || {};
	        configuration.callbacks = component.callbacks;
	        return plotter(container, configuration);
	    }
	
	    return {
	        init: init,
	        authorized: true,
	        properties: {
	            needTrack: true,
	            setter: {
	                'parentSize': 'resize'
	            },
	            events: {
	                "drawEnd": "onDrawEnd",
	                "brushEnd": "onBrushEnd",
	                "preLoad": "onPreLoad",
	                "enter": "onEnter",
	                "exit": "onExit",
	                "pointLeave": "onPointLeave",
	                "move": "onMove"
	            }
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5), __webpack_require__(6), __webpack_require__(8), __webpack_require__(9), __webpack_require__(10), __webpack_require__(11), __webpack_require__(12), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d3, _, localeHelper, gridLines, crosshairs, barSeries, dotSeries, ohlcSeries, candlestickSeries) {
	    'use strict';
	    return function(container, opt) {
	        var SELECTIONMODE = {
	            'PAN': 'pan',
	            'ZOOMIN': 'zoomin'
	        };
	        var option = {
	            locale: 'en-US',
	            xaxis: {
	                show: true,
	                align: 'bottom',
	                orient: 'bottom',
	                value: function(d) {
	                    return d.index;
	                },
	                minvalue: function(d) {
	                    return d.index;
	                },
	                maxvalue: function(d) {
	                    return d.index;
	                },
	                autoScaleMargin: 0,
	                height: 20,
	                marginTop: 4,
	                tick: {
	                    line: {
	                        show: false,
	                        spacing: 1,
	                        style: {
	                            'stroke': '#000',
	                            'stroke-width': '1px',
	                            'shape-rendering': 'crispEdges'
	                        }
	                    },
	                    text: {
	                        show: true,
	                        style: {
	                            "text-anchor": "start"
	                        }
	                    }
	                },
	                styleFun: function(elem) {
	                    var lineOpt = option.xaxis.tick.line,
	                        textOpt = option.xaxis.tick.text,
	                        xArray = [],
	                        lineArray = [],
	                        tickArray = elem.selectAll(".tick")[0];
	                    tickArray.forEach(function(e) {
	                        var tick = d3.select(e);
	                        xArray.push(d3.transform(tick.attr("transform")).translate[0]);
	                        lineArray.push(tick.select("line"));
	                    });
	                    var l = xArray.length;
	                    var width = l === 1 ? xArray[0] : (xArray[l - 1] - xArray[l - 2]);
	                    if (lineOpt.show) {
	                        for (var i = 0, l = lineArray.length; i < l; i++) {
	                            if (i === l - 1) {
	                                width = _width - xArray[i];
	                            } else {
	                                width = xArray[i + 1] - xArray[i]
	                            }
	                            lineArray[i].attr("x1", lineOpt.spacing)
	                                .attr("x2", width - lineOpt.spacing)
	                                .attr("y1", -option.xaxis.marginTop)
	                                .attr("y2", -option.xaxis.marginTop)
	                                .style(lineOpt.style);
	                        }
	                    }
	                    if (textOpt.show) {
	                        elem.selectAll("text").style(option.xaxis.tick.text.style).attr("x", 1).attr("y", 1);
	                        if (l >= 2) {
	                            var lastTick = d3.select(tickArray[l - 1]),
	                                firstTick = d3.select(tickArray[0]),
	                                secondTick = d3.select(tickArray[1]),
	                                penultTick = d3.select(tickArray[l - 2]),
	                                lastTickWidth = getTickTextWidth(lastTick),
	                                firstTickWidth = getTickTextWidth(firstTick),
	                                penultTickWidth = getTickTextWidth(penultTick);
	                            if (xArray[l - 1] + lastTickWidth > _width) {
	                                if (xArray[l - 1] - xArray[l - 2] < penultTickWidth + lastTickWidth) {
	                                    lastTick.selectAll('text').remove();
	                                } else {
	                                    lastTick.selectAll("text").attr("x", 0).style({
	                                        'text-anchor': 'end'
	                                    });
	                                }
	                            }
	                            if (xArray[1] - xArray[0] < firstTickWidth) {
	                                if (option.xaxis.indexArray) {
	                                    firstTick.selectAll('text').remove();
	                                    var secondTickText = option.xaxis.indexArray[0].dateTimeFormat(option.xaxis.indexArray[1].date);
	                                    secondTick.selectAll('text').text(secondTickText);
	                                } else {
	                                    firstTick.selectAll('text').remove();
	                                }
	                            }
	                        }
	                    } else {
	                        elem.selectAll("text").remove();
	                    }
	                    return elem;
	                },
	                /*dateTimeFormat: d3.time.format('%x'),
	                dateFormat: d3.time.format('%x'),
	                timeFormat: d3.time.format('%I:%M %p'),*/
	                tickFormat: function(v) {
	                    return option.xaxis.tickLabels && option.xaxis.tickLabels[v] ? option.xaxis.tickLabels[v] : v;
	                }
	            },
	            yaxis: {
	                show: true,
	                align: 'right',
	                orient: 'left',
	                scaleType: 'linear', //log
	                decimal: 2,
	                currency: 'USD',
	                currencySymbol: '$',
	                yAxisInfo: {},
	                value: function(d) {
	                    return +d.close;
	                },
	                minvalue: function(d) {
	                    return +d.low;
	                },
	                maxvalue: function(d) {
	                    return +d.high;
	                },
	                openvalue: function(d) {
	                    return +d.open;
	                },
	                highvalue: function(d) {
	                    return +d.high;
	                },
	                lowvalue: function(d) {
	                    return +d.low;
	                },
	                closevalue: function(d) {
	                    return +d.close;
	                },
	                autoScaleMargin: 0.02,
	                width: 50,
	                showLastlegend: true,
	                maxTickCount: 6,
	                tick: {
	                    line: {
	                        show: false,
	                        spacing: 2,
	                        style: {
	                            top: {
	                                'stroke': '#000',
	                                'stroke-width': '1px',
	                                'shape-rendering':   'crispEdges'
	                            },
	                            middle: {
	                                'stroke': '#000',
	                                'stroke-width': '1px',
	                                'shape-rendering':   'crispEdges'
	                            },
	                            bottom: {
	                                'stroke': '#000',
	                                'stroke-width': '1px',
	                                'shape-rendering':   'crispEdges'
	                            }
	                        }
	                    },
	                    text: {
	                        style: {}
	                    }
	                },
	                styleFun: function(elem) {
	                    var orient = elem.attr('data-orient');
	                    var align = elem.attr('data-align');
	                    var yaxisOpt = option.yaxis;
	                    var lineOpt = yaxisOpt.tick.line;
	                    var textOpt = yaxisOpt.tick.text;
	                    var ticks = elem.selectAll(".tick")[0];
	                    var _isInnerAxis = isInnerAxis(yaxisOpt);
	                    ticks.forEach(function(e, i) {
	                        var tick = d3.select(e);
	                        var text = tick.select('text').attr({
	                            "dy": "1em",
	                            "x": _isInnerAxis ? 0 : (orient === 'left' ? -yaxisOpt.width : yaxisOpt.width),
	                        }).style(_.extend({
	                            "text-anchor": getYTextAnchor()
	                        }, textOpt.style));
	                        var line;
	                        if (lineOpt.show) {
	                            line = tick.select('line').attr({
	                                'x1': orient === 'left' ? -yaxisOpt.width : yaxisOpt.width,
	                                'x2': orient === 'left' ? -lineOpt.spacing : lineOpt.spacing
	                            }).style(lineOpt.style.middle);
	                        }
	                        if (i === 0) {
	                            tick.classed('mstar-mkts-ui-plot-y-tick-bottom', true);
	                            if (line) {
	                                line.style(lineOpt.style.top);
	                                line.attr({
	                                    'y1': -0.5,
	                                    'y2': -0.5
	                                });
	                            }
	                            text.attr({
	                                'y': -option.xaxis.height
	                            });
	                        } else if (i === ticks.length - 1) {
	                            if (line) {
	                                line.style(lineOpt.style.bottom);
	                                line.attr({
	                                    'y1': 0.5,
	                                    'y2': 0.5
	                                });
	                            }
	                            tick.classed('mstar-mkts-ui-plot-y-text-top', true);
	                        }
	                    });
	                    return elem;
	                },
	
	                tickFormat: function(v) {
	                    if (typeof option.yaxis.numberFormat == 'function') {
	                        return option.yaxis.numberFormat(v, option.yaxis.yAxisInfo.tickValues);
	                    } else {
	                        return numberFormat(v);
	                    }
	                },
	                numberFormat: {}
	            },
	            highlight: {
	                show: true,
	                circle: {
	                    radius: 4,
	                    style: {
	                        'fill': 'none',
	                        'opacity': '0.8',
	                        'stroke-width': '2px',
	                        'stroke': '#006098'
	                    }
	                },
	                rect: {
	                    style: {
	                        'stroke-width': '2px',
	                        'stroke': '#000'
	                    }
	                }
	            },
	            gridlines: {
	                xLine: {
	                    show: true,
	                    style: {}
	                },
	                yLine: {
	                    show: true,
	                    style: {}
	                },
	                xRect: {
	                    show: false,
	                    style: {}
	                },
	                yRect: {
	                    show: false,
	                    style: {}
	                }
	            },
	            crosshairs: {
	                line: {
	                    horizontal: {
	                        show: false,
	                        style: {}
	                    },
	                    vertical: {
	                        show: false,
	                        style: {}
	                    },
	                    style: {}
	                },
	                circle: {
	                    show: false,
	                    radius: 5,
	                    style: {}
	                },
	                traceMouse: false
	            },
	            brush: {
	                autoHide: false,
	                style: {
	                    'fill': 'none'
	                },
	                mask: {
	                    show: false,
	                    style: {
	                        'fill': '#fff',
	                        'fill-opacity': '0.5'
	                    }
	                }
	            },
	            zoom: {
	                show: false,
	                responseInterval: 5
	            },
	            line: {
	                style: {
	                    'fill': 'none',
	                    'stroke': '#006098',
	                    'stroke-width': '1.5px'
	                }
	            },
	            area: {
	                style: {
	                    'fill': '#006098',
	                    'fill-opacity': '.4'
	                }
	            },
	            mountain: {},
	            bar: {
	                width: 'auto', // it could be number or auto, auto means it is calculated.
	                style: {
	                    'fill': '#006098'
	                }
	            },
	            dot: {
	                radius: 2,
	                style: {
	                    'fill': '#006098'
	                }
	            },
	            dotline: {},
	            ohlc: {
	                width: 'auto',
	                style: {
	                    'vector-effect': 'non-scaling-stroke',
	                    'stroke-width': '1.5px',
	                    'stroke': '#006098'
	                }
	            },
	            candlestick: {
	                width: 'auto',
	                style: {
	                    above: {
	                        rect: {
	                            'fill': '#FFFFFF',
	                            'stroke': '#349834'
	                        },
	                        path: {
	                            'stroke': '#349834'
	                        }
	                    },
	                    below: {
	                        rect: {
	                            'fill': '#FF0000',
	                            'stroke': '#FF0000'
	                        },
	                        path: {
	                            'stroke': '#FF0000'
	                        }
	                    }
	                }
	            },
	            abovebelow: {
	                style: {
	                    above: {
	                        'fill': '#92BC65',
	                        'opacity': '.8',
	                        'stroke': '#65A125'
	                    },
	                    below: {
	                        'fill': '#D86D72',
	                        'opacity': '.8',
	                        'stroke': '#CA3239'
	                    }
	                },
	                referValue: function(d) {
	                    return d.close;
	                }
	            },
	            invalid: function(d) {
	                return !isNaN(yValue(d));
	            },
	            callbacks: {
	                onMove: null
	            },
	            selectionMode: SELECTIONMODE.PAN
	        };
	        var numberFormat = new Intl.NumberFormat(option.locale || 'en-US', {
	            style: 'decimal',
	            currency: option.yaxis.currency || 'USD',
	            currencySymbol: option.yaxis.currencySymbol || '$',
	            minimumFractionDigits: option.yaxis.decimal || 2,
	            maximumFractionDigits: option.yaxis.decimal || 2
	        }).format;
	
	        //normal object
	        var _random = new Date().getTime(),
	            _width,
	            _height,
	            _seriesList = [],
	            _preloadSeriesList = [],
	            _zoomResponseCount = 0,
	            _zoomTranslateX,
	            _zoomingDomain = [],
	            _seriesCache = {
	                'graph': {},
	                'highlight': {}
	            };
	
	        //d3 object
	        var _container,
	            _svg,
	            _graph,
	            _highlight,
	            _xScale,
	            _yScale,
	            _xaxis,
	            _yaxis,
	            _gridlines,
	            _gridlinesG,
	            _corsshairs,
	            _brushMask,
	            _brush,
	            _brushG,
	            _zoom,
	            _zoomG,
	            _locale;
	
	        function plotter() {}
	
	        plotter.option = function(value) {
	            if (arguments.length == 0) {
	                return option;
	            }
	            if (option.selectionMode !== value.selectionMode) {
	                changeSelectionMode(value.selectionMode);
	            }
	            option = _.extend(true, {}, option, value);
	            if (value.xaxis && value.xaxis.tickValues) {
	                option.xaxis.tickValues = value.xaxis.tickValues;
	            }
	            if (value.yaxis && value.yaxis.tickValues) {
	                option.xaxis.tickValues = value.yaxis.tickValues;
	            }
	            return plotter;
	        };
	
	        function applyPreloadData(data){
	            if (!data || data.length === 0 || !data[0].data || data[0].data.length <= 0) {
	                return;
	            }
	            var loadedSeries,loadedData,preloadData;
	            if(_preloadSeriesList.length===0){
	                loadedSeries = _seriesList;
	            }else{
	                loadedSeries =  _preloadSeriesList;
	            }
	            _preloadSeriesList = processData(data);
	            for(var i=0;i<_preloadSeriesList.length;i++){
	                loadedData =loadedSeries[i].data;
	                preloadData=_preloadSeriesList[i].data; 
	                if(preloadData.length>0){
	                    var preStart = preloadData[0].date,
	                        preEnd= preloadData[preloadData.length-1].date,
	                        loadedStart = loadedData[0].date,
	                        loadedEnd = loadedData[loadedData.length-1].date,
	                        startIndex,
	                        endIndex;
	                    if(loadedStart <= preStart && loadedEnd<=preStart){
	                        startIndex=0;
	                        endIndex = loadedData.length;
	                        if(loadedEnd === preStart){
	                            endIndex--;
	                        }
	                        preloadData = loadedData.slice(startIndex,endIndex).concat(preloadData); 
	                    }else if(loadedStart <= preStart && loadedEnd > preStart && loadedEnd <= preEnd ){
	                        endIndex = getDataIndexByDate(loadedData,preStart);
	                        startIndex=0;
	                        if(loadedStart === preStart){
	                            startIndex++;
	                        }
	                        preloadData = loadedData.slice(startIndex,endIndex).concat(preloadData);
	                    }else if(loadedStart >= preStart && loadedEnd >= preEnd){ 
	                        startIndex = getDataIndexByDate(loadedData,preEnd)+1;
	                        endIndex = loadedData.length-1;
	                        if(loadedEnd > preEnd){
	                            endIndex ++;
	                        }
	                        preloadData = preloadData.concat(loadedData.slice(startIndex,endIndex));
	                    }else if(loadedStart>=preStart && loadedEnd<=preEnd){
	                        preloadData = preloadData;
	                    }   
	                }
	                _preloadSeriesList[i].data = preloadData;
	            }
	        }
	
	        function applyData(data) {
	            if (!_svg || !data || data.length === 0 || !data[0].data || data[0].data.length <= 0) {
	                _seriesList = [];
	                return;
	            }
	            //prepare process the data
	            _seriesList = processData(data);
	            //clear graph
	            _seriesCache = {
	                'graph': {},
	                'highlight': {}
	            };
	            if (_graph) {
	                _graph.selectAll('g').remove();
	            }
	            initYAxisInfo(data);
	            if (calculateSize()) {
	                _svg.attr('width', _width + getYaxisWidth());
	                _xScale.range([0, _width]);
	                var translate = getTranslate();
	                if (_gridlinesG) {
	                    _gridlinesG.attr("transform", translate);
	                }
	                if (_highlight) {
	                    _highlight.attr("transform", translate);
	                }
	                if (_graph) {
	                    _graph.attr("transform", translate);
	                }
	                if (_brushG) {
	                    _brushG.attr("transform", translate);
	                }
	                if (_brushMask) {
	                    _brushMask.attr("transform", translate);
	                }
	                if (_zoomG) {
	                    _zoomG.attr("transform", translate);
	                }
	                if (_corsshairs) {
	                    _corsshairs.translate(translate);
	                }
	                //to translat the axes
	                createAxes();
	            }
	            //change data domain
	            changeDomain(_seriesList);
	            //clear highlight circle
	            clearHighlight();
	            //draw series line
	            for (var i = 0, l = _seriesList.length; i < l; i++) {
	                drawSeries(_seriesList[i], i);
	            }
	            if (_.isFunction(option.callbacks.onDrawEnd)) {
	                option.callbacks.onDrawEnd({
	                    data: data,
	                    locale: _locale
	                });
	            }
	        }
	
	        plotter.preloadData = function(data) {
	            if (_.isArray(data) && data.length > 0 && data[0].data) {
	                applyPreloadData(data);
	            
	            } else if(_.isFunction(data.then)){
	                data.then(function(result){
	                    applyPreloadData(result);
	                });
	            }
	           return plotter;    
	        };
	
	        plotter.data = function(data) {
	            if (_.isArray(data)  && data.length>0 && data[0].data){
	                applyData(data);
	            } else if(_.isFunction(data.then)){
	                data.then(function(result){
	                    applyData(result);
	                });
	            }
	           return plotter;    
	        };
	
	        plotter.render = function() {
	            if (_seriesList.length > 0) {
	                plotter.destroy();
	                construct();
	                plotter.data(_seriesList);
	            }
	            return plotter;
	        };
	
	        plotter.output = function() {
	            return _container.html().replace(/clippath/g, 'clipPath');
	        };
	
	        plotter.resize = function(width, height) {
	            if (width <= 0 || height <= 0) {
	                return;
	            }
	            if (width !== option.width || height !== option.height) {
	                plotter.option({
	                    width: width,
	                    height: height
	                });
	                plotter.render();
	                if (option.brush.extent) {
	                    plotter.brushExtent(option.brush.extent);
	                }
	            }
	            return plotter;
	        };
	
	        plotter.destroy = function() {
	            _seriesCache = {
	                'graph': {},
	                'highlight': {}
	            };
	            _xScale = undefined;
	            _yScale = undefined;
	            _gridlines = undefined;
	            _corsshairs = undefined;
	            _xaxis = undefined;
	            _yaxis = undefined;
	            _graph = undefined;
	            _highlight = undefined;
	            _brush = undefined;
	            _brushG = undefined;
	            _brushMask = undefined;
	            _zoom = undefined;
	            _zoomG = undefined;
	            _locale = undefined;
	            if (_svg) {
	                _svg.on('.mstar-mkts-ui-plot', null);
	                _svg.remove();
	                _svg = undefined;
	            }
	            return plotter;
	        };
	
	        plotter.brushExtent = function(domain) {
	            if (_brush) {
	                option.brush.extent = domain;
	                _brush.extent(domain);
	                _brushG.call(_brush);
	                if (_brushMask) {
	                    var array = _brushMask.selectAll('rect')[0];
	                    d3.select(array[0]).attr('x', function() {
	                        return _xScale(domain[0]) - _width;
	                    });
	                    d3.select(array[1]).attr('x', function() {
	                        return _xScale(domain[1]);
	                    });
	                }
	            }
	            return plotter;
	        };
	
	        function construct(opts) {
	            _container = d3.select(container.jquery ? container[0] : container);
	            option = _.extend(true, {}, option, opts);
	            _locale = localeHelper.getLocale(option.locale);
	            //create SVG
	            createSVG();
	            //create scale
	            createScale();
	            //create gridlines
	            createGridLines();
	            //create hightcircle container
	            if (option.highlight.show) {
	                _highlight = _svg.append('g').attr('transform', getTranslate());
	            }
	            //create series container
	            _graph = _svg.append('g').attr('class', 'mstar-mkts-ui-plot-graph')
	                .attr('transform', getTranslate());
	            //create axes
	            createAxes();
	            //create crossharis
	            createCrossHaris();
	            //create brush
	            createBrush();
	            //create zoom
	            createZoom();
	            changeSelectionMode(option.selectionMode);
	            //bind event to svg
	            bindEvents();
	        }
	
	        function processData(data) {
	            var process = (data || []).slice();
	            process.forEach(function(series) {
	                (series.data || []).forEach(function(d, i) {
	                    if (!_.isDate(d.date)) {
	                        d.date = new Date(d.date);
	                    }
	                    d.index = i;
	                });
	            });
	            return process;
	        };
	
	        function changeSelectionMode(mode) {
	            switch (mode) {
	                case SELECTIONMODE.PAN:
	                    _brushG && _brushG.style('display', 'none');
	                    _zoomG && _zoomG.style('display', '');
	                    break;
	                case SELECTIONMODE.ZOOMIN:
	                    _brushG && _brushG.style('display', '');
	                    _zoomG && _zoomG.style('display', 'none');
	                    break;
	            }
	        }
	
	        function initYAxisInfo(data) {
	            var temp = calculateAxisExtreme(data) || {};
	            var _yAxisInfo = option.yaxis.yAxisInfo;
	            _yAxisInfo.tickCount = temp.tickCount;
	            _yAxisInfo.domain = temp.domain;
	            _yAxisInfo.factor = temp.factor;
	            _yAxisInfo.tickValues = option.yaxis.tickValues || generateYTickValues(_yAxisInfo.domain, _yAxisInfo.tickCount, _yAxisInfo.factor);
	            option.yaxis.width = getYTickWidth(_yAxisInfo.tickValues);
	        }
	
	        function changeDomain(data) {
	            var xaxisOpt = option.xaxis,
	                yaxisOpt = option.yaxis,
	                xTickValues = xaxisOpt.tickValues || generateXTickValues(data[0].data),
	                _yAxisInfo = option.yaxis.yAxisInfo;
	
	            var yDomain = _yAxisInfo.domain;
	            var yTickValues = _yAxisInfo.tickValues;
	            option.yaxis.decimal = (_yAxisInfo.factor.toString().split(".")[1] && _yAxisInfo.factor.toString().split(".")[1].length > option.yaxis.decimal) ? _yAxisInfo.factor.toString().split(".")[1].length : option.yaxis.decimal;
	            numberFormat = new Intl.NumberFormat(option.locale || 'en-US', {
	                style: 'decimal',
	                currency: option.yaxis.currency || 'USD',
	                currencySymbol: option.yaxis.currencySymbol || '$',
	                minimumFractionDigits: option.yaxis.decimal || 2,
	                maximumFractionDigits: option.yaxis.decimal || 2
	            }).format;
	            var dataLength = data[0].data.length;
	            _xScale.domain([0, dataLength - 1]);
	            _zoomingDomain = _xScale.domain();
	            _yScale.domain(yDomain);
	
	            if (_gridlines) {
	                _gridlines.xTicks(xTickValues).yTicks(yTickValues);
	                _gridlinesG.call(_gridlines);
	            }
	            if (_brush) {
	                _brush.x(_xScale);
	                _brushG.call(_brush);
	            }
	            if (_zoom) {
	                _zoom.x(_xScale).scaleExtent([0.5, data[0].data.length / 3]);
	                _zoomG.call(_zoom);
	            }
	            if (_xaxis) {
	                var _xElem = _svg.selectAll('.mstar-mkts-ui-plot-x');
	                _xaxis.tickValues(xTickValues);
	                _xElem.call(_xaxis).call(xaxisOpt.styleFun);
	                _xElem.select('.domain').style({
	                    'fill': 'none',
	                    'display': 'none'
	                });
	                if (!xaxisOpt.tick.line.show) {
	                    _xElem.selectAll('line').style({
	                        'display': 'none'
	                    });
	                }
	                //processTicks(_xElem, 'x');
	            }
	            if (_yaxis) {
	                var _yElem = _svg.selectAll('.mstar-mkts-ui-plot-y');
	                _yaxis.tickValues(yTickValues);
	                _yElem.call(_yaxis).call(yaxisOpt.styleFun);
	                _yElem.select('.domain').style({
	                    'fill': 'none',
	                    'display': 'none'
	                });
	                if (!yaxisOpt.tick.line.show) {
	                    _yElem.selectAll('line').style({
	                        'display': 'none'
	                    });
	                }
	                //processTicks(_yElem);
	            }
	
	        }
	
	        function getYDomain(dataList) {
	            var ymax = Number.NEGATIVE_INFINITY,
	                ymin = Number.POSITIVE_INFINITY;
	            dataList.forEach(function(series) {
	                series.graphType = (series.graphType ? series.graphType : 'line').toLowerCase();
	                series.isHLC = series.graphType === 'hlc' ? true : false;
	                series.graphType = /hlc$/.test(series.graphType) ? 'ohlc' : series.graphType;
	                var data = series.data;
	                var isOHLC = series.graphType === 'ohlc' || series.graphType === 'candlestick';
	                var invalid = option[series.graphType].invalid || option.invalid;
	                data.forEach(function(d) {
	                    var yminTemp = yValue(d, isOHLC ? 'min' : ''),
	                        ymaxTemp = yValue(d, isOHLC ? 'max' : '');
	                    if (!invalid(yminTemp) && yminTemp < ymin) {
	                        ymin = yminTemp;
	                    }
	                    if (!invalid(ymaxTemp) && ymaxTemp > ymax) {
	                        ymax = ymaxTemp;
	                    }
	                });
	            });
	            if (isFinite(ymin) && isFinite(ymax)) {
	                return [ymin, ymax]
	            } else {
	                return [0, 0];
	            }
	        }
	
	        function calculateAxisExtreme(dataList) {
	            var yDomain = getYDomain(dataList);
	            var maxTickCount = Math.min(option.yaxis.maxTickCount, caculateMaxTickCount()); // max tick count according to Height
	            return ajustDomainByAlgorithm(yDomain, maxTickCount);
	        }
	
	        function drawSeries(series, index) {
	            var _graphList = [];
	            switch (series.graphType) {
	                case 'line':
	                    _graphList.push(drawLines(series));
	                    drawHighlightCircle(index);
	                    break;
	                case 'area':
	                    _graphList.push(drawArea(series));
	                    drawHighlightCircle(index);
	                    break;
	                case 'mountain':
	                    _graphList.push(drawLines(series));
	                    _graphList.push(drawArea(series));
	                    drawHighlightCircle(index);
	                    break;
	                case 'dot':
	                    _graphList.push(drawDots(series));
	                    drawHighlightCircle(index);
	                    break;
	                case 'dotline':
	                    _graphList.push(drawDots(series));
	                    _graphList.push(drawLines(series));
	                    drawHighlightCircle(index);
	                    break;
	                case 'ohlc':
	                    _graphList.push(drawOHLC(series));
	                    drawHighlightRect(index);
	                    break;
	                case 'candlestick':
	                    _graphList.push(drawCandlestick(series));
	                    drawHighlightRect(index);
	                    break;
	                case 'abovebelow':
	                    _graphList.push(drawAboveBelow(series));
	                    drawHighlightCircle(index);
	                    break;
	                case 'bar':
	                    _graphList.push(drawBars(series));
	                    drawHighlightRect(index);
	                    break;
	                default:
	                    _graphList.push(drawLines(series));
	                    drawHighlightCircle(index);
	                    break;
	            }
	            var className = getSeriesClassName(index);
	            for (var i = 0, l = _graphList.length, _temp; i < l; i++) {
	                _temp = _graphList[i];
	                _temp.classed(className, true);
	                storeSeriesGraph(index, _temp);
	            }
	        }
	
	        function calculateSize() {
	            _width = option.width;
	            _height = option.height;
	            var oldWidth = _width;
	            var flag = _width <= 0 || _height <= 0;
	            if (!flag) {
	                _width = _width - getYaxisWidth();
	                _height = _height - getXaxisHeight();
	                flag = _width <= 0 || _height <= 0;
	            }
	            if (flag) {
	                throw 'Invalid dimensions for plot, width = ' + _width + ', height = ' + _height;
	            }
	            return oldWidth != _width;
	        }
	
	        function createSVG() {
	            calculateSize();
	            var margin = option.margin;
	            var w = _width + getYaxisWidth();
	            var h = _height + getXaxisHeight();
	            if (!_svg) {
	                _svg = _container
	                    .append('svg')
	                    .style({
	                        'display': 'block'
	                    })
	                    .attr('class', 'mstar-mkts-ui-plot')
	                    .attr('width', w)
	                    .attr('height', h)
	                    .attr('xmlns', 'http://www.w3.org/2000/svg');
	                //.attr('viewBox', '0 0 ' + w + ' ' + h);
	            } else {
	                _svg.attr({
	                    'width': w,
	                    'height': h
	                });
	            }
	        }
	
	        function createScale() {
	            if (!_xScale) {
	                _xScale = d3.scale.linear().range([0, _width]).nice(); //.domain([0, data.length - 1]);
	            }
	            if (!_yScale) {
	                _yScale = d3.scale[option.yaxis.scaleType]().range([_height, 0]).nice(); //.domain(yScaleDomain);
	            }
	        }
	
	        function createAxes() {
	            var translate;
	            var translateXY = getTranslate(true);
	            var xaxisOpt = option.xaxis;
	            var yaxisOpt = option.yaxis;
	            if (xaxisOpt.show && !_xaxis) {
	                _xaxis = createAxis(xaxisOpt, _xScale);
	                var xg = _svg.append('g')
	                    .attr('class', 'mstar-mkts-ui-plot-x mstar-mkts-ui-plot-axis')
	                    .attr('data-orient', xaxisOpt.orient)
	                    .attr('data-align', xaxisOpt.align);
	                if (xaxisOpt.align === 'bottom') {
	                    translate = [translateXY.x, _height + xaxisOpt.marginTop];
	                } else if (xaxisOpt.align === 'top') {
	                    translate = [translateXY.x, 0];
	                }
	                xg.attr('transform', 'translate(' + translate[0] + ',' + translate[1] + ')');
	            } else if (xaxisOpt.show && _xaxis) {
	                if (xaxisOpt.align === 'bottom') {
	                    translate = [translateXY.x, _height + xaxisOpt.marginTop];
	                } else if (xaxisOpt.align === 'top') {
	                    translate = [translateXY.x, 0];
	                }
	                var xg = _container.selectAll('.mstar-mkts-ui-plot-x');
	                xg.attr('transform', 'translate(' + translate[0] + ',' + translate[1] + ')');
	            }
	
	            if (yaxisOpt.show && !_yaxis) {
	                _yaxis = createAxis(yaxisOpt, _yScale);
	                var yg = _svg.append('g')
	                    .attr('class', 'mstar-mkts-ui-plot-y mstar-mkts-ui-plot-axis')
	                    .attr('data-orient', yaxisOpt.orient)
	                    .attr('data-align', yaxisOpt.align);
	                if (yaxisOpt.align === 'right') {
	                    translate = [_width, 0];
	                } else if (yaxisOpt.align === 'left') {
	                    translate = [translateXY.x, 0];
	                }
	                yg.attr('transform', 'translate(' + translate[0] + ',' + translate[1] + ')');
	            } else if (yaxisOpt.show && _yaxis) {
	                if (yaxisOpt.align === 'right') {
	                    translate = [_width, 0];
	                } else if (yaxisOpt.align === 'left') {
	                    translate = [translateXY.x, 0];
	                }
	                var yg = _container.selectAll('.mstar-mkts-ui-plot-y');
	                yg.attr('transform', 'translate(' + translate[0] + ',' + translate[1] + ')');
	            }
	
	        }
	
	        function createGridLines() {
	            if (isGridLinesShow(option.gridlines) && !_gridlines) {
	                _gridlinesG = _svg.append('g')
	                    .attr('class', 'mstar-mkts-ui-plot-gridlines-g')
	                    .attr('transform', getTranslate());
	                _gridlines = gridLines()
	                    .xLine(option.gridlines.xLine)
	                    .yLine(option.gridlines.yLine)
	                    .xRect(option.gridlines.xRect)
	                    .yRect(option.gridlines.yRect)
	                    .xScale(_xScale)
	                    .yScale(_yScale)
	                    .xTicks(option.xaxis.tickValues ? option.xaxis.tickValues : option.xaxis.ticks)
	                    .yTicks(option.yaxis.tickValues ? option.yaxis.tickValues : option.yaxis.ticks);
	            }
	        }
	
	        function createCrossHaris() {
	            if (isCrossHairsShow(option.crosshairs) && !_corsshairs) {
	                _corsshairs = crosshairs()
	                    .width(_width)
	                    .height(_height)
	                    .line(option.crosshairs.line)
	                    .circle(option.crosshairs.circle)
	                    .translate(getTranslate());
	                _svg.call(_corsshairs);
	            }
	        }
	
	        function bindEvents() {
	            _svg.on('mouseover.mstar-mkts-ui-plot', function() {
	                    mouseOver();
	                })
	                .on('mousemove.mstar-mkts-ui-plot  touchmove.mstar-mkts-ui-plot', function() {
	                    mouseMove();
	                })
	                .on('mouseout.mstar-mkts-ui-plot', function() {
	                    mouseOut();
	                });
	        }
	
	        function createZoom() {
	            if (option.zoom.show) {
	                _zoom = d3.behavior.zoom()
	                    .center([_width, 0])
	                    .x(_xScale)
	                    .on("zoomstart", function() {
	                        startZoom(_zoom);
	                    })
	                    .on("zoom", function() {
	                        zooming(_zoom);
	                    })
	                    .on("zoomend", function() {
	                        endZoom(_zoom);
	                    });
	
	                _zoomG = _svg.append('g')
	                    .attr('class', 'mstar-mkts-ui-plot-zoom')
	                    .style({
	                        'pointer-events': 'all'
	                    }).call(_zoom);
	
	                _zoomG.append('rect')
	                    .style({
	                        'fill': 'none'
	                    })
	                    .attr("width", _width)
	                    .attr("height", _height);
	            }
	        }
	
	        function createBrush() {
	            var _brushMaskLeft,
	                _brushMaskRight;
	            if (option.brush.mask.show) {
	                _brushMask = _svg.append('g')
	                    .attr('class', '-mask');
	                _brushMaskLeft = _brushMask.append('rect').attr({
	                    'width': _width,
	                    'height': _height,
	                    'x': -_width
	                }).style(option.brush.mask.style);
	
	                _brushMaskRight = _brushMask.append('rect').attr({
	                    'width': _width,
	                    'height': _height,
	                    'x': _width
	                }).style(option.brush.mask.style);
	            }
	
	            _brush = d3.svg.brush()
	                .x(_xScale)
	                .on("brushstart", function() {
	                    hideHighlight();
	                    toggleCrosshairs(false);
	                })
	                .on("brush", function() {
	                    if (_brushMask) {
	                        var domain = _brush.extent();
	                        _brushMaskLeft.attr('x', function() {
	                            return _xScale(domain[0]) - _width;
	                        });
	                        _brushMaskRight.attr('x', function() {
	                            return _xScale(domain[1]);
	                        });
	                    }
	                })
	                .on("brushend", function() {
	                    toggleCrosshairs(true);
	                    var domain = _brush.extent(),
	                        startIdx = Math.floor(domain[0]),
	                        endIdx = Math.ceil(domain[1]),
	                        series = getSeriesByIndex(0);
	                    option.brush.extent = domain;
	                    if (option.brush.autoHide) {
	                        _brush.clear();
	                        _brushG.call(_brush);
	                    }
	                    if (_.isFunction(option.callbacks.onBrushEnd)) {
	                        option.callbacks.onBrushEnd(series.data[startIdx], series.data[endIdx]);
	                    }
	                });
	
	            _brushG = _svg.append('g')
	                .attr('class', '')
	                .call(_brush);
	
	            _brushG.selectAll('rect')
	                .attr('height', _height)
	                .style(option.brush.style);
	
	            if (option.brush.image) {
	                var links = option.brush.image.links;
	                if (typeof links === 'string') {
	                    links = [links, links];
	                } else if (links.length < 2) {
	                    links = [links[0], links[0]];
	                }
	                var brushImageIDPrefix = new Date().getTime();
	                _brushG.selectAll(".resize").append("image")
	                    .attr("id", function(d, i) {
	                        return brushImageIDPrefix + "-" + i;
	                    }).attr({
	                        "width": option.brush.image.width,
	                        "height": _height,
	                        "x": -option.brush.image.width / 2,
	                        "y": 0,
	                        "xlink:href": function(d, i) {
	                            return links[i];
	                        }
	                    });
	
	            }
	        }
	
	        function toggleCrosshairs(showHide) {
	            if (_corsshairs) {
	                _corsshairs[showHide ? 'show' : 'hide']();
	            }
	        }
	
	        function startZoom(zoom) {
	            var translate = zoom.translate();
	            hideHighlight();
	            toggleCrosshairs(false);
	            _zoomG.attr({
	                'data-paning': '1',
	                'data-translate-x': translate[0]
	            });
	        }
	
	        function zooming(zoom) {
	            hideHighlight();
	            var translateX = zoom.translate()[0],
	                oriTranslateX = _zoomG.attr('data-translate-x'),
	                diffX = translateX - oriTranslateX;;
	
	            // if (domain[1] > (dataLength - 1)) {
	            //     translateX = translateX - _xScale(dataLength) + range[1];
	            // } else if (preloadDataLength + domain[0] < 0) {
	            //     translateX = translateX - _xScale(-preloadDataLength) + range[0];
	            // }
	
	            zoom.translate([translateX, 0]);
	            if (_zoomResponseCount !== option.zoom.responseInterval) {
	                _zoomResponseCount++;
	                _zoomTranslateX = translateX;
	            } else {
	                _zoomResponseCount = 0;
	                changeZoom();
	                _zoomTranslateX = undefined;
	            }
	        }
	
	        function endZoom(zoom) {
	            toggleCrosshairs(true);
	            _zoomG.attr({
	                'data-paning': '0',
	                'data-translate-x': zoom.translate()[0]
	            });
	            changeZoom();
	            _zoomingDomain = _xScale.domain();
	        }
	
	        function changeZoom() {
	            if (!_zoomTranslateX) {
	                return;
	            }
	            var newDomain = calculateZoomDomain();
	            var data = [];
	            _preloadSeriesList.forEach(function(series) {
	                var clone = _.extend(true, {}, series);
	                clone.data = clone.data.splice(newDomain[0], newDomain[1] - newDomain[0]);
	                data.push(clone);
	            });
	            plotter.data(data);
	        }
	        function calculateZoomDomain(){
	             var newDomain = _xScale.domain();
	             var oldDomain = _zoomingDomain.slice();
	             var preloadData = getPreLoadSeriesByIndex(0).data || getSeriesByIndex(0).data;
	             var renderData = getSeriesByIndex(0).data, 
	                  renderDataLength = renderData.length,
	                  preloadDataLength = preloadData.length,
	                  LastRenderIdx = renderDataLength-1,
	                  LastPreloadIdx = preloadDataLength - 1,
	                  startIdx,
	                  endIdx;
	             newDomain =[Math.ceil(newDomain[0]), Math.ceil(newDomain[1])];
	            
	             var scale =(newDomain[1]-newDomain[0]) / (oldDomain[1]-oldDomain[0]);
	             var speed = 1;
	             var startGap = Math.ceil((newDomain[0] - oldDomain[0]) *speed),
	                 endGap =  Math.ceil((newDomain[1] - oldDomain[1]) *speed);
	                 startIdx = getPreLoadIndexByDate(renderData[0].date) + startGap;
	                 endIdx = getPreLoadIndexByDate(renderData[LastRenderIdx].date) + endGap + 1;
	                if(Math.abs(startGap>10)){
	                  //  debugger;
	                }
	            if(startIdx<0 && endIdx > LastPreloadIdx){
	                return oldDomain;
	            } else if(startIdx<0){
	                startIdx = 0;
	                endIdx =Math.floor(renderDataLength * scale);
	            }else if(endIdx > LastPreloadIdx){
	                 endIdx = LastPreloadIdx;
	                 startIdx = Math.floor(endIdx - renderDataLength * scale);
	            }
	            var triggerPreload = false;
	            if(startIdx<0 && endIdx > LastPreloadIdx){
	                triggerPreload = true;
	                return oldDomain;
	            } else if(startIdx<0){
	                startIdx = 0;
	                endIdx =Math.floor(renderDataLength * scale);
	                triggerPreload = true;
	            }else if(endIdx > (LastPreloadIdx+1)){
	                 endIdx = LastPreloadIdx;
	                 startIdx = Math.floor(endIdx - renderDataLength * scale);
	                 triggerPreload = true;
	            }else if(endIdx< 2*(endIdx-startIdx) || (LastPreloadIdx-endIdx)< 2*(endIdx-startIdx)){
	                 triggerPreload = true;
	            }
	            if(triggerPreload && _.isFunction(option.callbacks.onPreLoad)){
	               option.callbacks.onPreLoad(_preloadSeriesList, endIdx -startIdx);
	            } 
	            return [startIdx, endIdx];  
	        }
	
	    
	        function getDataIndexByDate(data, date) {
	            var data = $.isArray(data) ? data : [],
	                idx;
	            for (var i = 0, l = data.length; i < l; i++) {
	                if (data[i].date.getTime() === date.getTime()) {
	                    idx = i;
	                    break;
	                }
	            }
	            return idx;
	        }
	
	        function getPreLoadIndexByDate(date) {
	            var preloadData = getPreLoadSeriesByIndex(0).data || getSeriesByIndex(0).data || [],
	                idx;
	            for (var i = 0, l = preloadData.length; i < l; i++) {
	                if (preloadData[i].date.getTime() === date.getTime()) {
	                    idx = i;
	                    break;
	                }
	            }
	            return idx;
	        }
	
	        function mouseOver() {
	            toggleCrosshairs(true);
	            if (_.isFunction(option.callbacks.onEnter)) {
	                option.callbacks.onEnter();
	            }
	        }
	
	        function mouseOut() {
	            hideHighlight();
	            toggleCrosshairs(false);
	            if (_.isFunction(option.callbacks.onExit)) {
	                option.callbacks.onExit();
	            }
	        }
	
	        function mouseMove() {
	            if (_svg.attr('data-paning') === '1') {
	                return;
	            }
	            var position = getSVGPosition();
	            if (position.length === 0) {
	                mouseOut();
	                return;
	            }
	            var nearests = findNearestPoints("ALL", position);
	            var toolTipData = [];
	            var tipPosition = [];
	            for (var i = 0; i < nearests.length; i++) {
	                var data = {};
	                var nearest = nearests[i];
	                var rPosition = [_xScale(xValue(nearest)), _yScale(yValue(nearest))];
	                var xy = option.crosshairs.traceMouse ? position : rPosition;
	                if (i === 0) {
	                    highlight(rPosition);
	                    if (_corsshairs) {
	                        _corsshairs.x(xy[0]).y(xy[1]);
	                    }
	                }
	                data.position = [rPosition[0] + (option.yaxis.orient === 'left' ? option.yaxis.width : 0), rPosition[1]];
	                data.item = nearest;
	                data.xy = xy;
	                data.rPosition = rPosition;
	                toolTipData.push(data);
	            }
	            var hasSelectedPoint = false;
	            for (var i = 0; i < toolTipData.length; i++) {
	                var rPosition = toolTipData[i].rPosition;
	                if (Math.abs(rPosition[0] - position[0]) <= 10 && Math.abs(rPosition[1] - position[1]) <= 10) {
	                    toolTipData[i]["selected"] = true;
	                    hasSelectedPoint = true;
	                }
	                delete toolTipData[i].rPosition;
	            }
	            if (hasSelectedPoint && _.isFunction(option.callbacks.onPointSelect)) {
	                option.callbacks.onPointSelect(toolTipData);
	            } else if (!hasSelectedPoint && _.isFunction(option.callbacks.onPointLeave)) {
	                option.callbacks.onPointLeave();
	            }
	
	            if (_.isFunction(option.callbacks.onMove)) {
	                option.callbacks.onMove(toolTipData);
	            }
	        }
	
	        function getSVGPosition() {
	            var position = d3.mouse(_svg[0][0]);
	            if (!isInnerAxis(option.yaxis)) {
	                if (option.yaxis.align === 'left') {
	                    position[0] -= option.yaxis.width;
	                }
	            }
	            if (position[0] < 0 || position[0] > _width || position[1] > _height) {
	                return [];
	            } else {
	                return position;
	            }
	        }
	
	        function highlight(position) {
	            if (_highlight) {
	                var hlCache = getHighlight();
	                var hl,
	                    nearest;
	                for (var index in hlCache) {
	                    hl = hlCache[index];
	                    nearest = findNearestPoints(index, position);
	                    if (nearest.length < 1) {
	                        continue;
	                    } else {
	                        nearest = nearest[0];
	                    }
	                    if (hl.circle) {
	                        var x = _xScale(xValue(nearest));
	                        var y = _yScale(yValue(nearest));
	                        hl.circle.attr('cx', x)
	                            .attr('cy', y)
	                            .attr('display', null);
	                    }
	                    if (hl.rect) {
	                        if (!_.isEmptyObject(hl.rect)) {
	                            hl.rect.classed('mstar-mkts-ui-plot-highlightbar', false);
	                        }
	                        var bars = getGraph(index).selectAll('.mstar-mkts-ui-plot-bar');
	                        bars.each(function(d, i) {
	                            if (i === nearest.__idx) {
	                                var bar = d3.select(this);
	                                bar.classed('mstar-mkts-ui-plot-highlightbar', true);
	                                storeSeriesHighlight(index, {
	                                    'rect': bar
	                                });
	                            }
	                        });
	                    }
	                }
	            }
	        }
	
	        function hideHighlightRect() {
	            var hlCache = getHighlight();
	            var hl;
	            for (var index in hlCache) {
	                hl = hlCache[index];
	                if (hl.rect && !_.isEmptyObject(hl.rect)) {
	                    hl.rect.classed('mstar-mkts-ui-plot-highlightbar', false);
	                }
	            }
	        }
	
	        function hideHighlight() {
	            if (_highlight) {
	                _highlight.selectAll('circle')
	                    .attr('display', 'none');
	                hideHighlightRect();
	            }
	        }
	
	        function clearHighlight() {
	            if (_highlight) {
	                _highlight.selectAll('circle').remove();
	                hideHighlightRect();
	            }
	        }
	
	        function findNearestPoints(index, position, forceFind) {
	            forceFind = forceFind === true ? true : false; //it is used by drawings
	            var seriesArr = [];
	            if (index == "ALL") {
	                seriesArr = _seriesList;
	            } else {
	                seriesArr.push(getSeriesByIndex(index));
	            }
	            var index = -1,
	                dataPoints = [];
	            for (var i = 0; i < seriesArr.length; i++) {
	                index = findNearestPointIndex(seriesArr[i], position);
	                if (index > -1) {
	                    seriesArr[i].data[index].__idx = index
	                    dataPoints.push(seriesArr[i].data[index]);
	                }
	            }
	            return dataPoints;
	        }
	
	        function findNearestPointIndex(series, position) {
	            var dataList = series.data;
	            if (!dataList || dataList.length === 0) {
	                return -1;
	            }
	            var dataLen = dataList.length;
	            var oriXMouse = _xScale.invert(position[0]);
	            var xMouse = Math.round((oriXMouse - _xScale.domain()[0]));
	            //handle boundary
	            if (xMouse < 0) {
	                xMouse = 0;
	            }
	            if (xMouse >= dataLen) {
	                xMouse = dataLen - 1;
	            }
	            var yValue = option.yaxis.value(dataList[xMouse]);
	            var defined = option[series.graphType] ? option[series.graphType].invalid : undefined;
	            defined = defined || option.invalid;
	            if (defined(yValue)) {
	                var factor;
	                if (oriXMouse >= xMouse) {
	                    factor = -1;
	                } else {
	                    factor = 1;
	                }
	                var loop = 1;
	                var leftSearched = false,
	                    rightSearched = false;
	                do {
	                    factor *= -1;
	                    xMouse = xMouse + factor * (loop++);
	                    if (xMouse < 0) {
	                        leftSearched = true;
	                        continue;
	                    } else if (xMouse >= dataLen) {
	                        rightSearched = true;
	                        continue;
	                    }
	                    yValue = option.yaxis.value(dataList[xMouse]);
	                } while (defined(yValue) && (!leftSearched || !rightSearched));
	            }
	            return xMouse;
	        }
	
	        function getSeriesByIndex(index) {
	            return _seriesList[index] || {};
	        }
	
	        function getPreLoadSeriesByIndex(index) {
	            return _preloadSeriesList[index] || {};
	        }
	
	        function getSeriesClassName(index) {
	            var series = getSeriesByIndex(index);
	            var className = series.className;
	            if (!series.className) {
	                className = "mstar-mkts-ui-plot-series-" + index;
	            }
	            return className;
	        }
	
	        function createAxis(opt, scale) {
	            var axis = d3.svg.axis().scale(scale).orient(opt.orient);
	            var array = ['ticks', 'tickSize', 'innerTickSize', 'outerTickSize', 'tickPadding', 'tickValues', 'tickFormat'];
	            for (var i = 0, l = array.length, attribute, realAttribute, a; i < l; i++) {
	                attribute = array[i];
	                realAttribute = attribute === 'outerTickSize' ? 'height' : attribute;
	                if (opt[realAttribute] && axis[attribute]) {
	                    axis[attribute](opt[realAttribute]);
	                }
	            }
	            return axis;
	        }
	
	        function drawHighlightCircle(index) {
	            if (_highlight) {
	                var color = getSeriesByIndex(index).color;
	                var extendStyle = {};
	                if (color) {
	                    extendStyle['stroke'] = color;
	                }
	                var circleStyle = _.extend(true, {}, option.highlight.circle.style, extendStyle);
	                var circle = _highlight.append("circle")
	                    .attr('data-index', index)
	                    .attr('class', 'mstar-mkts-ui-plot-highlight mstar-mkts-ui-plot-circle mstar-mkts-ui-plot-series-' + index)
	                    .attr('r', option.highlight.circle.radius)
	                    .attr('display', 'none')
	                    .style(circleStyle);
	
	                storeSeriesHighlight(index, {
	                    'circle': circle
	                });
	            }
	        }
	
	        function drawHighlightRect(index) {
	            if (_highlight) {
	                storeSeriesHighlight(index, {
	                    'rect': {}
	                });
	            }
	        }
	
	        function drawLines(series) {  
	           if (series.data) {
	               var _valid = 0;
	               for (var i = 0; i < series.data.length; i++) {
	                   if (!isNaN(yValue(series.data[i]))) {
	                       _valid++;
	                   }
	               }
	               if (_valid < 2) {
	                   return drawDots(series);
	               }
	           }
	           var line = d3.svg.line()
	                .x(function(d) {
	                    return _xScale(xValue(d));
	                })
	                .y(function(d) {
	                    return _yScale(yValue(d));
	                })
	                .defined(option.line.invalid || option.invalid);
	
	            var lineseries = _graph.append('g').attr('class', 'mstar-mkts-ui-plot-line-series').style(getStyle('line', series));
	            lineseries.append('path').attr('d', line(series.data));
	
	            return lineseries;
	        }
	
	        function drawArea(series) {
	            var area = d3.svg.area()
	                .x(function(d) {
	                    return _xScale(xValue(d));
	                })
	                .y0(_height)
	                .y1(function(d) {
	                    return _yScale(yValue(d));
	                })
	                .defined(option.area.invalid || option.invalid);
	
	            var target = _graph.append('g').attr('class', 'mstar-mkts-ui-plot-area-series').style(getStyle('area', series));
	            var clipId = series.clipId || _random + '#clip';
	
	            createClipPath(target, clipId);
	
	            target.append('path')
	                .attr('clip-path', 'url(#' + clipId + ')')
	                .attr('d', area(series.data));
	
	            return target;
	        }
	
	        function drawBars(series) {
	            var bar = barSeries()
	                .width(_width)
	                .height(_height)
	                .tickSize(calculateTickSize(option.bar.width, series.data))
	                .style(getStyle('bar', series))
	                .xScale(_xScale)
	                .yScale(_yScale)
	                .xValue(function(d) {
	                    return xValue(d);
	                })
	                .yValue(function(d) {
	                    return yValue(d);
	                })
	                .defined(option.bar.invalid || option.invalid);
	
	            var target = _graph.append('g');
	            target.datum(series.data).call(bar);
	            return target;
	        }
	
	        function drawDots(series) {
	            var dot = dotSeries()
	                .style(getStyle('dot', series))
	                .tickSize(option.dot.radius)
	                .x(function(d) {
	                    return _xScale(xValue(d));
	                })
	                .y(function(d) {
	                    return _yScale(yValue(d));
	                })
	                .defined(option.dot.invalid || option.invalid);
	
	            var target = _graph.append('g');
	            target.datum(series.data).call(dot);
	            return target;
	        }
	
	        function drawOHLC(series) {
	            var ohlc = ohlcSeries()
	                .isHLC(series.isHLC)
	                .style(getStyle('ohlc', series))
	                .tickSize(calculateTickSize(option.ohlc.width, series.data))
	                .xScale(_xScale)
	                .yScale(_yScale)
	                .xValue(function(d) {
	                    return xValue(d);
	                })
	                .yOValue(function(d) {
	                    return yValue(d, 'open');
	                })
	                .yHValue(function(d) {
	                    return yValue(d, 'high');
	                })
	                .yLValue(function(d) {
	                    return yValue(d, 'low');
	                })
	                .yCValue(function(d) {
	                    return yValue(d, 'close');
	                })
	                .defined(option.ohlc.invalid || option.invalid);
	
	            var target = _graph.append('g');
	            target.datum(series.data).call(ohlc);
	            return target;
	        }
	
	        function drawCandlestick(series) {
	            var candlestick = candlestickSeries()
	                .style(getStyle('candlestick', series))
	                .tickSize(calculateTickSize(option.candlestick.width, series.data))
	                .xScale(_xScale)
	                .yScale(_yScale)
	                .xValue(function(d) {
	                    return xValue(d);
	                })
	                .yOValue(function(d) {
	                    return yValue(d, 'open');
	                })
	                .yHValue(function(d) {
	                    return yValue(d, 'high');
	                })
	                .yLValue(function(d) {
	                    return yValue(d, 'low');
	                })
	                .yCValue(function(d) {
	                    return yValue(d, 'close');
	                })
	                .defined(option.ohlc.invalid || option.invalid);
	
	            var target = _graph.append('g');
	            target.datum(series.data).call(candlestick);
	            return target;
	        }
	
	        function drawAboveBelow(series) {
	            var referValue = option.abovebelow.referValue(series.data[0]);
	            var yClipValue = _yScale(referValue);
	            var clipArea = d3.svg.area()
	                .x(function(d) {
	                    return _xScale(xValue(d));
	                })
	                .y1(yClipValue)
	                .defined(option.abovebelow.invalid || option.invalid);
	
	            var abArea = d3.svg.area()
	                .x(function(d) {
	                    return _xScale(xValue(d));
	                })
	                .y1(function(d) {
	                    return _yScale(yValue(d));
	                })
	                .defined(option.abovebelow.invalid || option.invalid);
	
	            var target = _graph.append('g').attr('class', 'mstar-mkts-ui-plot-abovebelow-series');
	            var aboveClipId = series.aboveClipId || 'clip-above-' + _random;
	            var belowClipId = series.belowClipId || 'clip-below-' + _random;
	
	            target.datum(series.data);
	
	            var defs = target.append('defs');
	
	            defs.append('clipPath')
	                .attr('id', aboveClipId)
	                .append('rect')
	                .attr('x', 0)
	                .attr('y', 0)
	                .attr('width', _width)
	                .attr('height', yClipValue);
	
	            defs.append('clipPath')
	                .attr('id', belowClipId)
	                .append('rect')
	                .attr('x', 0)
	                .attr('y', yClipValue)
	                .attr('width', _width)
	                .attr('height', _height - yClipValue);
	
	            target.append('path')
	                .style(getStyle('abovebelow', series).above)
	                .attr('class', 'mstar-mkts-ui-plot-above-series')
	                .attr("clip-path", "url(#" + aboveClipId + ")")
	                .attr("d", abArea.y0(_height));
	
	            target.append('path')
	                .style(getStyle('abovebelow', series).below)
	                .attr('class', 'mstar-mkts-ui-plot-below-series')
	                .attr("clip-path", "url(#" + belowClipId + ")")
	                .attr("d", abArea.y0(0));
	
	            return target;
	        }
	
	        function createClipPath(target, id) {
	            target.append('clipPath')
	                .attr('id', id)
	                .append('rect')
	                .attr('width', _width)
	                .attr('height', _height);
	        }
	
	        function xValue(d, type) {
	            type = typeof type === 'undefined' ? '' : type;
	            return option.xaxis[type + 'value'](d);
	        }
	
	        function yValue(d, type) {
	            type = typeof type === 'undefined' ? '' : type;
	            return option.yaxis[type + 'value'](d);
	        }
	
	        function isInnerAxis(axisOpt) {
	            return axisOpt.align !== axisOpt.orient;
	        }
	
	        function getYaxisWidth() {
	            return !option.yaxis.show || isInnerAxis(option.yaxis) ? 0 : option.yaxis.width;
	        }
	
	        function getXaxisHeight() {
	            return !option.xaxis.show || isInnerAxis(option.xaxis) ? 0 : (option.xaxis.height + option.xaxis.marginTop);
	        }
	
	        function getTranslate(onlyNumber) {
	            var x = option.yaxis.align === 'right' ? 0 : getYaxisWidth(),
	                y = option.xaxis.align === 'bottom' ? 0 : getXaxisHeight();
	            return onlyNumber ? {
	                x: x,
	                y: y
	            } : 'translate(' + x + ',' + y + ')';
	        }
	
	        function calculateTickSize(size, data) {
	            var tickSize = size;
	            if (tickSize === 'auto') {
	                tickSize = _width / data.length - 1;
	                tickSize = Math.min(tickSize, 30);
	                tickSize = Math.max(tickSize, 1);
	            }
	            return tickSize;
	        }
	
	        function getLastTick(elem, xy) {
	            var ticks = elem.selectAll(".tick")[0];
	            if (xy === 'x') {
	                return d3.select(ticks[ticks.length - 1]);
	            } else {
	                return d3.select(ticks[0]);
	            }
	        }
	
	        function getTickTextWidth(elem) {
	            var width = 0;
	            elem.select('text').each(function() {
	                width = this.getBoundingClientRect().width;
	            });
	            return width;
	        }
	
	        function getTickTextHeight(elem) {
	            var height = 0;
	            elem.select('text').each(function() {
	                height = this.getBoundingClientRect().height;
	            });
	            return height;
	        }
	
	        function storeSeriesHighlight(index, highlight) {
	            _seriesCache.highlight[index] = _seriesCache.highlight[index] || {};
	            _.extend(_seriesCache.highlight[index], highlight);
	        }
	
	        function storeSeriesGraph(index, graph) {
	            _seriesCache.graph[index] = graph;
	        }
	
	        function getGraph(index) {
	            if (arguments.length > 0) {
	                return _seriesCache.graph[index];
	            }
	            return _seriesCache.graph;
	        }
	
	        function getHighlight(index) {
	            if (arguments.length > 0) {
	                return _seriesCache.highlight[index];
	            }
	            return _seriesCache.highlight;
	        }
	
	        function getStyle(graphType, series) {
	            var style = option[graphType].style;
	            var color = series.color;
	            if (color) {
	                switch (graphType) {
	                    case 'line':
	                    case 'ohlc':
	                        style.stroke = color;
	                        break;
	                    case 'area':
	                    case 'dot':
	                    case 'bar':
	                        style.fill = color;
	                        break;
	
	                }
	            }
	            return style; //_.merge({}, option[graphType].style, (series.style || {})[graphType]);
	        }
	
	        function isCrossHairsShow(crosshairs) {
	            return crosshairs.line.horizontal.show === true || crosshairs.line.vertical.show === true || crosshairs.circle.show === true;
	        }
	
	        function isGridLinesShow(gridlines) {
	            return gridlines.xLine.show === true || gridlines.yLine.show === true || gridlines.xRect.show === true || gridlines.yRect.show === true;
	        }
	
	        function caculateMaxTickCount() {
	            var height = option.height;
	            var textHeight = getyTickHeight();
	            var space = 10;
	            var maxTickCount = parseInt(height / (textHeight * 2 + space), 10);
	            if (option.yaxis.maxTickCount && option.yaxis.maxTickCount < maxTickCount) {
	                maxTickCount = option.yaxis.maxTickCount;
	            }
	            return maxTickCount < 2 ? 2 : maxTickCount;
	        }
	
	        function generateYTickValues(domain, tickCount, factor) {
	            var tickValues = [];
	            if (option.yaxis.scaleType == "log") {
	                if (domain[0] < 1) {
	                    var adjustOffset = 1 - domain[0];
	                    domain[0] = 1;
	                    domain[1] = domain[1] + adjustOffset;
	                }
	            }
	            for (var i = 0; i < tickCount; i++) {
	                tickValues.push(domain[0] + factor * i);
	            }
	            return tickValues;
	        }
	
	        function ajustDomainByAlgorithm(domain, maxTickCount) {
	            var _factors = [0.01, 0.015, 0.02, 0.025, 0.03, 0.04, 0.05, 0.075];
	            var min = domain[0];
	            var max = domain[1];
	            var range = max - min;
	            var adjustedMax,
	                adjustedMin;
	            var maxExponent = 20;
	            var tickCount;
	            var yAxisInfo = {
	                domain: domain,
	                tickCount: tickCount,
	                factor: 0.01
	            }
	            if (range == 0) {
	                //max==min==factor
	                factor = max = min;
	                tickCount = (maxTickCount % 2) ? maxTickCount : (maxTickCount - 1);
	                adjustedMax = max + Math.floor(tickCount / 2) * factor;
	                adjustedMin = min - Math.floor(tickCount / 2) * factor;
	                domain[0] = adjustedMin;
	                domain[1] = adjustedMax;
	                yAxisInfo.domain = domain;
	                yAxisInfo.tickCount = tickCount;
	                yAxisInfo.factor = factor
	                return yAxisInfo;
	            } else if (range <= 0.01) {
	                var temp = 10;
	                maxExponent = 3;
	                for (var i = maxExponent; i > 0; i--) {
	                    for (var f in _factors) {
	                        var factor = _factors[f] * Math.pow(10, -i);
	                        if ((maxTickCount - 1) * factor > range) {
	                            var offset = factor - Math.abs(max % factor);
	                            adjustedMax = max + offset;
	                            tickCount = parseInt((adjustedMax - min) / factor) + 1;
	                            tickCount += ((adjustedMax - min) % factor == 0) ? 0 : 1;
	                            adjustedMin = adjustedMax - (tickCount - 1) * factor;
	                            if (tickCount < maxTickCount) {
	                                domain[0] = adjustedMin;
	                                domain[1] = adjustedMax;
	                                yAxisInfo.domain = domain;
	                                yAxisInfo.tickCount = tickCount;
	                                yAxisInfo.factor = factor
	                                return yAxisInfo;
	                            }
	                        }
	                    }
	                }
	            } else {
	                for (var i = 0; i < maxExponent; i++) {
	                    for (var f in _factors) {
	                        var factor = _factors[f] * Math.pow(10, i);
	                        if ((maxTickCount - 1) * factor - range > 0.01 * range) {
	                            var offset = factor - Math.abs(max % factor);
	                            //offset = (offset <= factor * 0.1) ? factor * 0.1 : offset;
	                            adjustedMax = max + offset;
	                            tickCount = parseInt((adjustedMax - min) / factor) + 1;
	                            tickCount += ((adjustedMax - min) % factor == 0) ? 0 : 1;
	                            adjustedMin = adjustedMax - (tickCount - 1) * factor;
	                            if (tickCount <= maxTickCount) {
	                                domain[0] = adjustedMin;
	                                domain[1] = adjustedMax;
	                                yAxisInfo.domain = domain;
	                                yAxisInfo.tickCount = tickCount;
	                                yAxisInfo.factor = factor;
	                                return yAxisInfo;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        function getYTextAnchor() {
	            return option.yaxis.align === 'left' ? 'start' : 'end';
	        }
	
	        function getXTickWidth(dataArray) {
	            var width = 0,
	                temp;
	            var style = _.extend({
	                display: 'inline-block'
	            }, option.xaxis.tick.text.style);
	            var span = _container.append('span').style(style);
	            dataArray.forEach(function(data) {
	                temp = span.html(data.dateTimeFormat(data.d.date))[0][0].getBoundingClientRect().width;
	                if (temp > width) {
	                    width = temp;
	                }
	            })
	            span.remove();
	            return width + 5;
	        }
	
	        function getYTickWidth(dataArray) {
	            var width = 0,
	                temp;
	            var style = _.extend({
	                display: 'inline-block'
	            }, option.yaxis.tick.text.style);
	            var span = _container.append('span').style(style);
	            dataArray.forEach(function(data) {
	                temp = parseInt(span.html(option.yaxis.tickFormat(data))[0][0].getBoundingClientRect().width, 10);
	                if (temp > width) {
	                    width = temp;
	                }
	            })
	            span.remove();
	            if (width + option.yaxis.tick.line.spacing > option.yaxis.width) {
	                width = width + option.yaxis.tick.line.spacing + 6;
	            } else {
	                width = option.yaxis.width;
	            }
	            return width;
	        }
	
	        function getyTickHeight() {
	            var height = 15;
	            var style = _.extend({
	                display: 'inline-block'
	            }, option.yaxis.tick.text.style);
	            var span = _container.append('span').style(style);
	            height = span.html(option.yaxis.tickFormat(1234567890))[0][0].getBoundingClientRect().height;
	            span.remove();
	            return height;
	        }
	
	        function generateStep(steps, step, start, len, maxTickCount) {
	            //var steps = type === 'date' ? [1, 3, 6, 12, 36, 60, 120] : [15, 30, 60, 120, 240, 360, 720, 1440];
	            var interval = 1;
	            var newStep;
	            for (var i = start, l = steps.length, d; i < l; i++) {
	                d = steps[i];
	                if (d % step === 0) {
	                    newStep = d;
	                    interval = newStep / step;
	                    break;
	                }
	            }
	            if (len / interval <= maxTickCount) {
	                return interval;
	            } else {
	                if (i >= (l - 1)) {
	                    return len;
	                } else {
	                    return generateStep(steps, step, i + 1, len, maxTickCount);
	                }
	            }
	        }
	
	        function splitByDate(xData) {
	            var ret = [],
	                indexs = [0],
	                start = xData[0],
	                format = _locale.timeFormat('%Y%m%d'),
	                dateTimeFormat = _locale.timeFormat('%I:%M %p'),
	                data = [{
	                    d: start,
	                    dateTimeFormat: dateTimeFormat
	                }];
	            for (var i = 1, l = xData.length, d; i < l; i++) {
	                d = xData[i];
	                if (format(d.date) != format(start.date)) {
	                    indexs.push(i);
	                    start = d;
	                }
	                data.push({
	                    d: d,
	                    dateTimeFormat: dateTimeFormat
	                });
	            }
	
	            for (var j = 0, jl = indexs.length; j < jl; j++) {
	                if (j < jl - 1) {
	                    ret.push(data.slice(indexs[j], indexs[j + 1]))
	                } else {
	                    ret.push(data.slice(indexs[j]));
	                }
	            }
	            return ret;
	        }
	
	        function generateXTickValues(xData) {
	            var size = xData.length;
	            var tickValues = [];
	            if (size === 1) {
	                tickValues.push(0);
	                option.xaxis.tickLabels = {};
	                option.xaxis.tickLabels[xValue(xData[0])] = _locale.timeFormat("mmmdd")(xData[0].date);
	            } else {
	                var daysDiff = (xData[size - 1].date.getTime() - xData[0].date.getTime()) / (60 * 24 * 60 * 1000),
	                    start = xData[0].date,
	                    func,
	                    dateTimeFormat,
	                    steps = [],
	                    dividend,
	                    interval = (xData[1].date.getTime() - xData[0].date.getTime()) / (60 * 1000);
	                if (interval < 1440 && daysDiff <= 1) { //one day
	                    steps = [15, 30, 60, 120, 240, 360, 720, 1440];
	                    func = function(s, d) {
	                        return true;
	                    };
	                    dateTimeFormat = function(d) {
	                        return _locale.timeFormat('%I:%M %p');
	                    };
	                } else { //more than one day, then display the days
	                    interval = 1;
	                    steps = [1, 2, 4, 8, 16];
	                    if (daysDiff <= 31) {
	                        func = function(s, d) {
	                            return d.getDate() !== s.getDate();
	                        };
	                        dateTimeFormat = function(d) {
	                            return _locale.timeFormat("mmmdd");
	                        };
	                    } else if (daysDiff <= 61) {
	                        func = function(s, d) {
	                            return d.getDate() !== s.getDate();
	                        };
	                        dateTimeFormat = function(d) {
	                            return _locale.timeFormat("mmmdd");
	                        };
	                    } else if (daysDiff <= 240) {
	                        func = function(s, d) {
	                            return d.getMonth() !== s.getMonth();
	                        };
	                        dateTimeFormat = function(d) {
	                            return _locale.timeFormat('%b');
	                        };
	                    } else if (daysDiff <= 730) {
	                        func = function(s, d) {
	                            return (d.getMonth() + 1) % 3 === 1 && s.getMonth() !== d.getMonth()
	                        };
	                        dateTimeFormat = function(d) {
	                            return _locale.timeFormat('%b');
	                        };
	                    } else if (daysDiff <= 2920) {
	                        func = function(s, d) {
	                            return s.getFullYear() !== d.getFullYear();
	                        };
	                        dateTimeFormat = function(d) {
	                            return _locale.timeFormat('%Y');
	                        };
	                    } else {
	                        func = function(s, d) {
	                            return s.getFullYear() !== d.getFullYear() && d.getFullYear() % 5 === 0;
	                        };
	                        dateTimeFormat = function(d) {
	                            return _locale.timeFormat('%Y');
	                        };
	                    }
	                }
	                option.xaxis.tickLabels = {};
	                option.xaxis.indexArray = [];
	                var indexArray = [{
	                    d: xData[0],
	                    dateTimeFormat: dateTimeFormat(xData[0].date)
	                }];
	                for (var i = 1, temp; i < size; i++) {
	                    temp = xData[i].date;
	                    if (func(start, temp)) {
	                        start = temp;
	                        indexArray.push({
	                            d: xData[i],
	                            dateTimeFormat: dateTimeFormat(temp)
	                        });
	                    }
	                }
	                if (daysDiff > 61 && daysDiff <= 730) {
	                    indexArray[0].dateTimeFormat = _locale.timeFormat('%b %Y');
	                }
	                var tickWidth = getXTickWidth(indexArray);
	                var step = generateStep(steps, interval, 0, indexArray.length, Math.floor(_width / tickWidth) + 1);
	                for (var i = 0, l = indexArray.length, d; i < l; i += step) {
	                    d = indexArray[i].d;
	                    tickValues.push(xValue(d));
	                    option.xaxis.tickLabels[xValue(d)] = indexArray[i].dateTimeFormat(d.date);
	                    option.xaxis.indexArray.push({
	                        dateTimeFormat: indexArray[i].dateTimeFormat,
	                        date: indexArray[i].d.date
	                    });
	                }
	            }
	            return tickValues;
	        }
	        construct(opt);
	
	        return plotter;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	
	    var hasOwn = Object.prototype.hasOwnProperty;
	    var toString = Object.prototype.toString;
	
	    function isFunction(obj) {
	        return toString.call(obj) === '[object Function]';
	    }
	
	    function isDate(obj) {
	        return toString.call(obj) === '[object Date]';
	    }
	
	    function isWindow(obj) {
	        return obj !== null && obj === obj.window;
	    }
	
	    function isPlainObject(obj) {
	        if (toString.call(obj) !== '[object Object]' || obj.nodeType || isWindow(obj)) {
	            return false;
	        }
	        if (obj.constructor && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
	            return false;
	        }
	        return true;
	    }
	
	    function isEmptyObject(obj) {
	        var name;
	        for (name in obj) {
	            return false;
	        }
	        return true;
	    }
	
	    function isArray(obj) {
	        return toString.call(obj) === '[object Array]';
	    }
	
	    function extend() {
	        var options, name, src, copy, copyIsArray, clone,
	            target = arguments[0] || {},
	            i = 1,
	            length = arguments.length,
	            deep = false;
	
	        // Handle a deep copy situation
	        if (typeof target === "boolean") {
	            deep = target;
	
	            // Skip the boolean and the target
	            target = arguments[i] || {};
	            i++;
	        }
	
	        // Handle case when target is a string or something (possible in deep copy)
	        if (typeof target !== "object" && !isFunction(target)) {
	            target = {};
	        }
	
	        for (; i < length; i++) {
	            // Only deal with non-null/undefined values
	            if ((options = arguments[i]) != null) {
	                // Extend the base object
	                for (name in options) {
	                    src = target[name];
	                    copy = options[name];
	
	                    // Prevent never-ending loop
	                    if (target === copy) {
	                        continue;
	                    }
	
	                    // Recurse if we're merging plain objects or arrays
	                    if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
	                        if (copyIsArray) {
	                            copyIsArray = false;
	                            clone = src && isArray(src) ? src : [];
	
	                        } else {
	                            clone = src && isPlainObject(src) ? src : {};
	                        }
	
	                        // Never move original objects, clone them
	                        target[name] = extend(deep, clone, copy);
	
	                        // Don't bring in undefined values
	                    } else if (copy !== undefined) {
	                        target[name] = copy;
	                    }
	                }
	            }
	        }
	
	        // Return the modified object
	        return target;
	    }
	
	    return {
	        isFunction: isFunction,
	        isDate: isDate,
	        isPlainObject: isPlainObject,
	        isEmptyObject: isEmptyObject,
	        isArray: isArray,
	        extend: extend
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d3) {
	    'use strict';
	    var localeJson = __webpack_require__(7);
	    var getLocale = function(locale) {
	        var localeObject = {};
	        var specifier;
	        if (localeJson[locale]) {
	            specifier = localeJson[locale];
	        } else {
	            var lang = locale.split('-')[0];
	            specifier = localeJson[lang] || localeJson['en'];
	        }
	        var d3_locale = d3.locale(specifier);
	        localeObject.timeFormat = function(template) {
	            template = specifier[template] || template;
	            return d3_locale.timeFormat(template);
	        }
	        localeObject.numberFormat = d3_locale.numberFormat;
	        return localeObject;
	    };
	
	    return {
	        getLocale: getLocale
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = {"en":{"decimal":".","thousands":",","grouping":[3],"currency":["$",""],"dateTime":"%a %b %e %X %Y","date":"%m/%d/%Y","time":"%H:%M:%S","periods":["AM","PM"],"days":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"shortDays":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"months":["January","February","March","April","May","June","July","August","September","October","November","December"],"shortMonths":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"mmmdd":"%b %d","mmmdd,yyyy":"%b %d, %Y"},"fr":{"decimal":",","thousands":" ","grouping":[3],"dateTime":"%A, le %e %B %Y, %X","date":"%d/%m/%Y","time":"%H:%M:%S","periods":["AM","PM"],"days":["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],"shortDays":["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],"months":["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],"shortMonths":["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."],"mmmdd":"%d %b","mmmdd,yyyy":"%d %b %Y"},"zh":{"decimal":".","thousands":",","grouping":[3],"currency":["$",""],"dateTime":"%a %b %e %X %Y","date":"%m/%d/%Y","time":"%H:%M:%S","periods":["AM","PM"],"days":["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],"shortDays":["周日","周一","周二","周三","周四","周五","周六"],"months":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],"shortMonths":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],"mmmdd":"%b %d","mmmdd,yyyy":"%m/%d/%Y"},"zh-TW":{"decimal":".","thousands":",","grouping":[3],"currency":["$",""],"dateTime":"%a %b %e %X %Y","date":"%m/%d/%Y","time":"%H:%M:%S","periods":["AM","PM"],"days":["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],"shortDays":["週日","週一","週二","週三","週四","週五","週六"],"months":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],"shortMonths":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],"mmmdd":"%b %d","mmmdd,yyyy":"%m/%d/%Y"},"zh-HK":{"decimal":".","thousands":",","grouping":[3],"currency":["$",""],"dateTime":"%a %b %e %X %Y","date":"%m/%d/%Y","time":"%H:%M:%S","periods":["AM","PM"],"days":["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],"shortDays":["週日","週一","週二","週三","週四","週五","週六"],"months":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],"shortMonths":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],"mmmdd":"%b %d","mmmdd,yyyy":"%m/%d/%Y"},"jp":{"decimal":".","thousands":",","grouping":[3],"currency":["$",""],"dateTime":"%a %b %e %X %Y","date":"%m/%d/%Y","time":"%H:%M:%S","periods":["AM","PM"],"days":["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],"shortDays":["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],"months":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],"shortMonths":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],"mmmdd":"%b %d","mmmdd,yyyy":"%Y年%m月%d日"}}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d3, _) {
	    return function() {
	        "use strict";
	        var xLine = {
	                show: true,
	                style: {
	                    'stroke': '#d3d3d3',
	                    'stroke-dasharray': '1 3',
	                    'shape-rendering':   'crispEdges'
	                }
	            },
	            yLine = {
	                show: true,
	                style: {
	                    top: {
	                        'stroke': '#d3d3d3',
	                        'stroke-dasharray': '1 3',
	                        'shape-rendering':   'crispEdges'
	                    },
	                    middle: {
	                        'stroke': '#d3d3d3',
	                        'stroke-dasharray': '1 3',
	                        'shape-rendering':   'crispEdges'
	                    },
	                    bottom: {
	                        'stroke': '#d3d3d3',
	                        'stroke-dasharray': '1 3',
	                        'shape-rendering':   'crispEdges'
	                    }
	                }
	            },
	            xRect = {
	                show: false,
	                oddStyle: {
	                    fill: '#ddd'
	                },
	                evenStyle: {
	                    fill: '#ffffff'
	                }
	            },
	            yRect = {
	                show: false,
	                oddStyle: {
	                    fill: '#f0f0f0'
	                },
	                evenStyle: {
	                    fill: '#ffffff'
	                }
	            },
	            xScale,
	            yScale,
	            xTicks,
	            yTicks,
	            translate;
	
	        var xLines = function(data, grid) {
	            var xlines = grid.selectAll(".mstar-mkts-ui-plot-grid-x").data(data)
	                .enter()
	                .append("line")
	                .style(xLine.style)
	                .attr({
	                    "class": "mstar-mkts-ui-plot-grid-x",
	                    "x1": function(d) {
	                        return xScale(d);
	                    },
	                    "x2": function(d) {
	                        return xScale(d);
	                    },
	                    "y1": yScale.range()[0],
	                    "y2": yScale.range()[1]
	                });
	        };
	
	        var yLines = function(data, grid) {
	            var ylines = grid.selectAll('.mstar-mkts-ui-plot-grid-y').data(data)
	                .enter()
	                .append('line')
	                .style(yLine.style)
	                .attr({
	                    'class': 'mstar-mkts-ui-plot-grid-y',
	                    'x1': xScale.range()[0],
	                    'x2': xScale.range()[1],
	                    'y1': function(d) {
	                        return (yScale(d) == yScale.range()[0]) ? yScale(d) - 0.5 : yScale(d) + 0.5;
	                    },
	                    'y2': function(d) {
	                        return (yScale(d) == yScale.range()[0]) ? yScale(d) - 0.5 : yScale(d) + 0.5;
	                    }
	                });
	            ylines[0].forEach(function(e, i) {
	                var l = d3.select(e);
	                if (i === 0) {
	                    l.classed('mstar-mkts-ui-plot-grid-y-bottom', true).style(yLine.style.bottom);
	                } else if (i === ylines[0].length - 1) {
	                    l.classed('mstar-mkts-ui-plot-grid-y-top', true).style(yLine.style.top);
	                } else {
	                    l.style(yLine.style.middle);
	                }
	            });
	        };
	
	        var drawXRect = function(data, grid) {
	            var xArray = [],
	                rects = [],
	                width = xScale.range()[1],
	                len = data.length;
	            data.forEach(function(d, index) {
	                var x = xScale(d);
	                if (x < width) {
	                    xArray.push(x);
	                    rects.push(grid.append('rect').attr({
	                        'class': 'mstar-mkts-ui-plot-grid-x-rect',
	                        'x': xScale(d),
	                        'y': 0,
	                        'height': Math.abs(yScale.range()[1] - yScale.range()[0])
	                    }));
	                }
	            });
	            var lastX = xArray[xArray.length - 1];
	            if (width > lastX) {
	                xArray.push(width);
	            }
	
	            for (var i = 0, l = rects.length; i < l; i++) {
	                rects[i]
	                    .attr('width', xArray[i + 1] - xArray[i])
	                    .style(i % 2 === 0 ? xRect.oddStyle : xRect.evenStyle);
	            }
	        };
	
	        var gridlines = function(selection) {
	            var xTickData = xTicks ? (Array.isArray(xTicks) ? xTicks : xScale.ticks(xTicks)) : xScale.ticks(),
	                yTickData = yTicks ? (Array.isArray(yTicks) ? yTicks : yScale.ticks(yTicks)) : yScale.ticks(),
	                grid = selection.select('.mstar-mkts-ui-plot-gridlines');
	
	            if (!grid.empty()) {
	                grid.remove();
	            }
	            grid = selection.append('g').classed('mstar-mkts-ui-plot-gridlines', true).attr('transform', translate);
	            if (xRect.show) {
	                drawXRect(xTickData, grid);
	            }
	            if (xLine.show) {
	                xLines(xTickData, grid);
	            }
	            if (yLine.show) {
	                yLines(yTickData, grid);
	            }
	            /*selection.each(function () {
	            xTickData = xTicks ? (Array.isArray(xTicks) ? xTicks : xScale.ticks(xTicks)) : xScale.ticks();
	            yTickData = yTicks ? (Array.isArray(yTicks) ? yTicks : yScale.ticks(yTicks)) : yScale.ticks();
	            grid = d3.select(this).selectAll('.mstar-mkts-ui-plot-gridlines').data([[xTickData, yTickData]])
	            .enter().append('g').classed('mstar-mkts-ui-plot-gridlines', true).attr('transform', translate);
	            if (xRect.show) {
	            drawXRect(xTickData, grid);
	            }
	            if (xLine.show) {
	            xLines(xTickData, grid);
	            }
	            if (yLine.show) {
	            yLines(yTickData, grid);
	            }
	            });*/
	        };
	
	        gridlines.xLine = function(value) {
	            if (!arguments.length) {
	                return xLine;
	            }
	            xLine = _.extend(true, {}, xLine, value);
	            return gridlines;
	        };
	
	        gridlines.yLine = function(value) {
	            if (!arguments.length) {
	                return yLine;
	            }
	            yLine = _.extend(true, {}, yLine, value);
	            return gridlines;
	        };
	
	        gridlines.xRect = function(value) {
	            if (!arguments.length) {
	                return xRect;
	            }
	            xRect = _.extend(true, {}, xRect, value);
	            return gridlines;
	        };
	
	        gridlines.yRect = function(value) {
	            if (!arguments.length) {
	                return yRect;
	            }
	            yRect = _.extend(true, {}, yRect, value);
	            return gridlines;
	        };
	
	        gridlines.xScale = function(value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return gridlines;
	        };
	
	        gridlines.yScale = function(value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return gridlines;
	        };
	
	        gridlines.xTicks = function(value) {
	            if (!arguments.length) {
	                return xTicks;
	            }
	            xTicks = value;
	            return gridlines;
	        };
	
	        gridlines.yTicks = function(value) {
	            if (!arguments.length) {
	                return yTicks;
	            }
	            yTicks = value;
	            return gridlines;
	        };
	
	        gridlines.translate = function(value) {
	            if (!arguments.length) {
	                return translate;
	            }
	            translate = value;
	            return gridlines;
	        };
	
	        return gridlines;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d3, _) {
	    return function() {
	        'use strict';
	        var width = 0,
	            height = 0,
	            x = 0,
	            y = 0,
	            mouseX = 0,
	            mouseY = 0,
	            line = {
	                horizontal: {
	                    show: true,
	                    style: {}
	                },
	                vertical: {
	                    show: true,
	                    style: {}
	                },
	                style: {
	                    'fill': 'none',
	                    'stroke': '#666',
	                    'stroke-width': '1px',
	                    'stroke-dasharray': '3px 1px'
	                }
	            },
	            circle = {
	                show: true,
	                radius: 4,
	                style: {
	                    'fill': 'none',
	                    'stroke': '#0039b7',
	                    'stroke-width': '1px'
	                }
	            },
	            _lineH,
	            _lineV,
	            _circle,
	            _translate;
	
	        var crosshairs = function(selection) {
	            var root = selection.append('g').attr('class', 'mstar-mkts-ui-plot-crosshairs').attr('transform', _translate);
	            if (line.horizontal.show) {
	                _lineH = root.append('line')
	                    .style(_.extend(line.style, line.horizontal.style))
	                    .attr('class', 'mstar-mkts-ui-plot-corssharis mstar-mkts-ui-plot-horizontal')
	                    .attr('x1', 0)
	                    .attr('x2', width)
	                    .attr('y1', y)
	                    .attr('y2', y)
	                    .attr('display', 'none');
	            }
	            if (line.vertical.show) {
	                _lineV = root.append("line")
	                    .style(_.extend(line.style, line.vertical.style))
	                    .attr('class', 'mstar-mkts-ui-plot-crosshairs mstar-mkts-ui-plot-vertical')
	                    .attr('x1', x)
	                    .attr('x2', x)
	                    .attr('y1', height)
	                    .attr('y2', 0)
	                    .attr('display', 'none');
	            }
	            if (circle.show === true) {
	                _circle = root.append("circle")
	                    .style(circle.style)
	                    .attr('class', 'mstar-mkts-ui-plot-crosshairs mstar-mkts-ui-plot-circle')
	                    .attr('r', circle.radius)
	                    .attr('cx', x)
	                    .attr('cy', y)
	                    .attr('display', 'none');
	            }
	
	        };
	
	        crosshairs.width = function(value) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = value;
	            return crosshairs;
	        };
	
	        crosshairs.height = function(value) {
	            if (!arguments.length) {
	                return height;
	            }
	            height = value;
	            return crosshairs;
	        };
	
	        crosshairs.x = function(value) {
	            if (!arguments.length) {
	                return x;
	            }
	            x = value;
	            if (_lineV) {
	                _lineV.attr('x1', x).attr('x2', x);
	            }
	            if (_circle) {
	                _circle.attr('cx', x);
	            }
	            return crosshairs;
	        };
	
	        crosshairs.y = function(value) {
	            if (!arguments.length) {
	                return y;
	            }
	            y = value;
	            if (_lineH) {
	                _lineH.attr('y1', y).attr('y2', y);
	            }
	            if (_circle) {
	                _circle.attr('cy', y);
	            }
	            return crosshairs;
	        };
	
	        crosshairs.show = function() {
	            if (_lineH) {
	                _lineH.attr('display', null);
	            }
	            if (_lineV) {
	                _lineV.attr('display', null);
	            }
	            if (_circle) {
	                _circle.attr('display', null);
	            }
	            return crosshairs;
	        };
	        crosshairs.hide = function() {
	            if (_lineH) {
	                _lineH.attr('display', 'none');
	            }
	            if (_lineV) {
	                _lineV.attr('display', 'none');
	            }
	            if (_circle) {
	                _circle.attr('display', 'none');
	            }
	            return crosshairs;
	        };
	        crosshairs.line = function(value) {
	            if (!arguments.length) {
	                return line;
	            }
	            _.extend(true, line, value);
	            return crosshairs;
	        };
	        crosshairs.circle = function(value) {
	            if (!arguments.length) {
	                return circle;
	            }
	            _.extend(true, circle, value);
	            return crosshairs;
	        };
	        crosshairs.translate = function(value) {
	            if (!arguments.length) {
	                return _translate;
	            }
	            _translate = value;
	            return crosshairs;
	        };
	        return crosshairs;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d3, _) {
	    return function() {
	        'use strict';
	        var xScale,
	            yScale,
	            xValue,
	            yValue,
	            tickSize = 5,
	            fillColor,
	            strokeColor,
	            width,
	            height,
	            baseValue,
	            style = {},
	            defined = function() {
	                return true;
	            };
	
	        var xFun = function(d) {
	            return xScale(xValue(d)) - tickSize / 2;
	        };
	
	        var yFun = typeof baseValue === 'number' ? function(d) {
	            return isUp(d) ? yScale(yValue(d)) : yScale(baseValue);
	        } : function(d) {
	            return yScale(yValue(d));
	        };
	
	        var heightFun = typeof baseValue === 'number' ? function(d) {
	            return isUp(d) ? (yScale(baseValue) - yScale(yValue(d))) : (yScale(baseValue) - yScale(baseValue));
	        } : function(d) {
	            return height - yScale(yValue(d));
	        };
	
	        var isUp = typeof baseValue === 'number' ? function(d) {
	            return yValue(d) > baseValue;
	        } : function(d) {
	            return false;
	        };
	
	        var isDown = typeof baseValue === 'number' ? function(d) {
	            return yValue(d) < baseValue;
	        } : function(d) {
	            return false;
	        };
	
	        var drawRectangle = function(bar) {
	            var rect = bar.append('rect')
	                .style(style)
	                .attr("x", function(d) {
	                    var x = xFun(d);
	                    return x < 0 ? 0 : x;
	                })
	                .attr("y", yFun)
	                .attr("width", function(d) {
	                    var x = xFun(d);
	                    if (x < 0 || x + tickSize > width) {
	                        return tickSize / 2;
	                    } else {
	                        return tickSize;
	                    }
	                })
	                .attr("height", heightFun);
	        };
	
	        /*var zoom = d3.behavior.zoom()
	        .x(xScale)
	        .scaleExtent([1, 50])
	        .on('zoom', zoomed)
	        .on('zoomend', zoomend);*/
	
	        var bar = function(selection) {
	            var series,
	                bar;
	            selection.each(function(data) {
	                var outerElem = d3.select(this).append('g').classed("mstar-mkts-ui-plot-bar-series", true);
	                var i = -1,
	                    n = data.length,
	                    d;
	                while (++i < n) {
	                    if (defined.call(this, d = data[i], i)) {
	                        bar = outerElem.append("g").data([d])
	                            .classed({
	                                'mstar-mkts-ui-plot-bar': true,
	                                'mstar-mkts-ui-plot-up': isUp,
	                                'mstar-mkts-ui-plot-down': isDown
	                            });
	
	                        drawRectangle(bar);
	                    }
	                }
	            });
	
	            if (fillColor || strokeColor) {
	                var style = {};
	                if (fillColor) {
	                    style.fill = fillColor;
	                }
	                if (strokeColor) {
	                    style.stroke = strokeColor;
	                }
	                selection.selectAll("rect").style(style);
	            }
	        };
	
	        //bar.zoom = function (selection) {
	        //    var xDomain = xScale.domain();
	        //    var xRange = xScale.range();
	        //    var translate = zoom.translate()[0];
	        //}
	
	        bar.xScale = function(value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return bar;
	        };
	
	        bar.yScale = function(value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return bar;
	        };
	
	        bar.tickSize = function(value) {
	            if (!arguments.length) {
	                return tickSize;
	            }
	            tickSize = value;
	            return bar;
	        };
	
	        bar.width = function(value) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = value;
	            return bar;
	        };
	
	        bar.height = function(value) {
	            if (!arguments.length) {
	                return height;
	            }
	            height = value;
	            return bar;
	        };
	
	        bar.baseValue = function(value) {
	            if (!arguments.length) {
	                return baseValue;
	            }
	            baseValue = +value;
	            return bar;
	        };
	
	        bar.fillColor = function(value) {
	            if (!arguments.length) {
	                return fillColor;
	            }
	            fillColor = value;
	            return bar;
	        };
	
	        bar.strokeColor = function(value) {
	            if (!arguments.length) {
	                return strokeColor;
	            }
	            strokeColor = value;
	            return bar;
	        };
	
	        bar.defined = function(value) {
	            if (!arguments.length) {
	                return defined;
	            }
	            defined = value;
	            return bar;
	        };
	
	        bar.xValue = function(value) {
	            if (!arguments.length) {
	                return xValue;
	            }
	            xValue = value;
	            return bar;
	        };
	
	        bar.yValue = function(value) {
	            if (!arguments.length) {
	                return yValue;
	            }
	            yValue = value;
	            return bar;
	        };
	
	        bar.style = function(value) {
	            if (!arguments.length) {
	                return style;
	            }
	            _.extend(style, value);
	            return bar;
	        };
	
	        return bar;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d3, _) {
	    'use strict';
	    return function() {
	        var tickSize = 2;
	        var style = {};
	        var defined = function() {
	            return true;
	        };
	        var func = function(v) {
	            return typeof v === "function" ? v : function() {
	                return v;
	            };
	        };
	        var x = func,
	            y = func;
	
	        var dot = function(selection) {
	            var series,
	                dot;
	            selection.each(function(data) {
	                var outerElem = d3.select(this).append("g").classed("mstar-mkts-ui-plot-dot-series", true);
	                var i = -1,
	                    n = data.length,
	                    d;
	                while (++i < n) {
	                    if (defined.call(this, d = data[i], i)) {
	                        dot = outerElem.append("circle")
	                            .style(style)
	                            .attr("r", tickSize)
	                            .attr("cx", x(d))
	                            .attr("cy", y(d));
	                    }
	                }
	            });
	        };
	
	        dot.tickSize = function(value) {
	            if (!arguments.length) {
	                return tickSize;
	            }
	            tickSize = value;
	            return dot;
	        };
	
	        dot.x = function(value) {
	            if (!arguments.length) {
	                return x;
	            }
	            x = value;
	            return dot;
	        };
	
	        dot.y = function(value) {
	            if (!arguments.length) {
	                return y;
	            }
	            y = value;
	            return dot;
	        };
	
	        dot.defined = function(value) {
	            if (!arguments.length) {
	                return defined;
	            }
	            defined = value;
	            return dot;
	        };
	
	        dot.style = function(value) {
	            if (!arguments.length) {
	                return style;
	            }
	            _.extend(style, value);
	            return dot;
	        };
	
	        return dot;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d3, _) {
	    'use strict';
	    return function() {
	        var xScale,
	            yScale,
	            tickSize = 5,
	            isHLC = false,
	            xValue,
	            yOValue,
	            yHValue,
	            yLValue,
	            yCValue,
	            style = {};
	        var defined = function() {
	            return true;
	        };
	
	        var isUpDay = function(d) {
	            return yCValue(d) > yOValue(d);
	        };
	
	        var line = d3.svg.line()
	            .x(function(d) {
	                return d.x;
	            })
	            .y(function(d) {
	                return d.y;
	            });
	
	        var highLowLines = function(bar) {
	            bar.append("path")
	                .style(style)
	                .classed("mstar-mkts-ui-plot-high-low-line", true)
	                .attr("d", function(d) {
	                    var x = xScale(xValue(d));
	                    return line([{
	                        x: x,
	                        y: yScale(yHValue(d))
	                    }, {
	                        x: x,
	                        y: yScale(yLValue(d))
	                    }]);
	                });
	        };
	
	        var openTicks = function(bar) {
	            bar.append("path")
	                .style(style)
	                .classed("mstar-mkts-ui-plot-open-tick", true)
	                .attr("d", function(d) {
	                    var x = xScale(xValue(d));
	                    var x1,
	                        x2;
	                    x1 = x - tickSize;
	                    x2 = x;
	                    var y = yScale(yOValue(d));
	                    return line([{
	                        x: x1,
	                        y: y
	                    }, {
	                        x: x2,
	                        y: y
	                    }]);
	                });
	        };
	
	        var closeTicks = function(bar) {
	            var close = bar.append("path")
	                .style(style)
	                .classed("mstar-mkts-ui-plot-close-tick", true)
	                .attr("d", function(d) {
	                    var x = xScale(xValue(d));
	                    var x1,
	                        x2;
	                    x1 = x;
	                    x2 = x + tickSize;
	                    var y = yScale(yCValue(d));
	                    return line([{
	                        x: x1,
	                        y: y
	                    }, {
	                        x: x2,
	                        y: y
	                    }]);
	                });
	        };
	
	        var ohlc = function(selection) {
	            var bar;
	            selection.each(function(data) {
	                var outerElem = d3.select(this).append('g').classed('mstar-mkts-ui-plot-ohlc-series', true);
	                var i = -1,
	                    n = data.length,
	                    d,
	                    isUp;
	                while (++i < n) {
	                    if (defined.call(this, d = data[i], i)) {
	                        isUp = isUpDay(d);
	                        bar = outerElem.append('g').data([d])
	                            .classed({
	                                'mstar-mkts-ui-plot-bar': true,
	                                'mstar-mkts-ui-plot-up-day': isUp,
	                                'mstar-mkts-ui-plot-down-day': !isUp
	                            });
	
	                        highLowLines(bar);
	
	                        if (!ohlc.isHLC()) {
	                            openTicks(bar);
	                        }
	                        closeTicks(bar);
	                    }
	                }
	            });
	        };
	
	        ohlc.xScale = function(value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return ohlc;
	        };
	
	        ohlc.yScale = function(value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return ohlc;
	        };
	
	        ohlc.tickSize = function(value) {
	            if (!arguments.length) {
	                return tickSize;
	            }
	            tickSize = value / 2;
	            return ohlc;
	        };
	
	        ohlc.isHLC = function(value) {
	            if (!arguments.length) {
	                return isHLC;
	            }
	            isHLC = value;
	            return ohlc;
	        };
	        ohlc.defined = function(value) {
	            if (!arguments.length) {
	                return defined;
	            }
	            defined = value;
	            return ohlc;
	        };
	
	        ohlc.xValue = function(value) {
	            if (!arguments.length) {
	                return xValue;
	            }
	            xValue = value;
	            return ohlc;
	        };
	
	        ohlc.yOValue = function(value) {
	            if (!arguments.length) {
	                return yOValue;
	            }
	            yOValue = value;
	            return ohlc;
	        };
	
	        ohlc.yHValue = function(value) {
	            if (!arguments.length) {
	                return yHValue;
	            }
	            yHValue = value;
	            return ohlc;
	        };
	
	        ohlc.yLValue = function(value) {
	            if (!arguments.length) {
	                return yLValue;
	            }
	            yLValue = value;
	            return ohlc;
	        };
	
	        ohlc.yCValue = function(value) {
	            if (!arguments.length) {
	                return yCValue;
	            }
	            yCValue = value;
	            return ohlc;
	        };
	
	        ohlc.style = function(value) {
	            if (!arguments.length) {
	                return style;
	            }
	            _.extend(style, value);
	            return ohlc;
	        };
	
	        return ohlc;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d3, _) {
	    return function() {
	        "use strict";
	        var xScale,
	            yScale;
	        var cacheData,
	            cacheScale;
	        var tickSize = 5;
	        var xValue,
	            yOValue,
	            yHValue,
	            yLValue,
	            yCValue,
	            style = {
	                above: {},
	                below: {}
	            };
	        var defined = function() {
	            return true;
	        };
	
	        var isUpDay = function(d) {
	            return yCValue(d) > yOValue(d);
	        };
	
	        var getStyle = function(element, isUp) {
	            if (isUp) {
	                return style.above[element];
	            }
	            return style.below[element];
	        };
	
	        var line = d3.svg.line()
	            .x(function(d) {
	                return d.x;
	            }).y(function(d) {
	                return d.y;
	            });
	
	        var highLowLines = function(bar, isUp) {
	            var paths = bar.append("path")
	                .style(getStyle('path', isUp))
	                .classed({
	                    "mstar-mkts-ui-plot-high-low-line": true
	                })
	                .attr("d", function(d) {
	                    var x = xScale(xValue(d));
	                    return line([{
	                        "x": x,
	                        "y": yScale(yHValue(d))
	                    }, {
	                        "x": x,
	                        "y": yScale(yLValue(d))
	                    }]);
	                });
	        };
	
	        var rectangles = function(bar, isUp) {
	            var rect = bar.append('rect')
	                .style(getStyle('rect', isUp))
	                .attr("x", function(d) {
	                    return xScale(xValue(d)) - tickSize / 2;
	                })
	                .attr("y", function(d) {
	                    return isUp ? yScale(yCValue(d)) : yScale(yOValue(d));
	                })
	                .attr("width", tickSize)
	                .attr("height", function(d) {
	                    return Math.max(0.5, isUp ? (yScale(yOValue(d)) - yScale(yCValue(d))) : (yScale(yCValue(d)) - yScale(yOValue(d))));
	                });
	        };
	
	        /*var zoom = d3.behavior.zoom()
	        .x(xScale)
	        .scaleExtent([1, 50])
	        .on('zoom', zoomed)
	        .on('zoomend', zoomend);*/
	
	        var candlestick = function(selection) {
	            var bar;
	            selection.each(function(data) {
	                var outerElem = d3.select(this).append('g').classed('mstar-mkts-ui-plot-candlestick-series', true);
	                var i = -1,
	                    n = data.length,
	                    d,
	                    isUp;
	                while (++i < n) {
	                    if (defined.call(this, d = data[i], i)) {
	                        isUp = isUpDay(d);
	                        bar = outerElem.append('g').data([d])
	                            .classed({
	                                'mstar-mkts-ui-plot-bar': true,
	                                'mstar-mkts-ui-plot-up': isUp,
	                                'mstar-mkts-ui-plot-down': !isUp
	                            });
	
	                        highLowLines(bar, isUp);
	                        rectangles(bar, isUp);
	                    }
	                }
	            });
	        };
	
	        //candlestick.zoom = function (selection) {
	        //    var xDomain = xScale.domain();
	        //    var xRange = xScale.range();
	        //    var translate = zoom.translate()[0];
	        //}
	
	        candlestick.xScale = function(value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return candlestick;
	        };
	
	        candlestick.yScale = function(value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return candlestick;
	        };
	
	        candlestick.tickSize = function(value) {
	            if (!arguments.length) {
	                return tickSize;
	            }
	            tickSize = value;
	            return candlestick;
	        };
	
	        candlestick.defined = function(value) {
	            if (!arguments.length) {
	                return defined;
	            }
	            defined = value;
	            return candlestick;
	        };
	
	        candlestick.xValue = function(value) {
	            if (!arguments.length) {
	                return xValue;
	            }
	            xValue = value;
	            return candlestick;
	        };
	
	        candlestick.yOValue = function(value) {
	            if (!arguments.length) {
	                return yOValue;
	            }
	            yOValue = value;
	            return candlestick;
	        };
	
	        candlestick.yHValue = function(value) {
	            if (!arguments.length) {
	                return yHValue;
	            }
	            yHValue = value;
	            return candlestick;
	        };
	
	        candlestick.yLValue = function(value) {
	            if (!arguments.length) {
	                return yLValue;
	            }
	            yLValue = value;
	            return candlestick;
	        };
	
	        candlestick.yCValue = function(value) {
	            if (!arguments.length) {
	                return yCValue;
	            }
	            yCValue = value;
	            return candlestick;
	        };
	
	        candlestick.style = function(value) {
	            if (!arguments.length) {
	                return style;
	            }
	            _.extend(style, value);
	            return candlestick;
	        };
	
	        return candlestick;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;
//# sourceMappingURL=markets-components-svgplot.js.map